import React, { useEffect, useRef, useState,useLayoutEffect } from "react";
import SearchBar from "./CommonComponents/SearchBar";
import { Services } from "../network/Services";
import { formatDateIntoDDMMYY, formatDateLocal, formatDateLocalPST,formatDateByZone , getTodayDateUSFormat, isNotValidNullUndefile } from "../control/Constant";
import AddNewUser from "./AddNewUser";
import SearchableSelect from "./CustomSelect";
import Toaster from "./Toaster";
import AoUrl from '../network/url';
import FederalWayRefundForm from "./FederalWay/FederalWayRefundForm";
// import { formatToUSD } from "../network/helper";


const Refund = ({paymentData,setPaymentData,setuseLoader,setSelectedUserData,subtinentId,setToast,timeMatter,setTimematter,setSelectedCompany,addOrderUser,resetToCompanySelection,resetToLifepaointdata,refundRefreshTrigger}) => {
    const [matterNumber, setMatterNumber] = useState("");
    const [showDropdown, setShowDropdown] = useState(false);
    const [results, setResults] = useState([]);
    const [showUserForm, setshowUserForm] = useState(false)
    const [selectedUser, setSelecteduser] = useState('')
    const [serviceType,setServiceType] = useState('')
    const [service, setService] = useState()
    const [orderDetails,setOrderdetails] = useState(null)
    const [refundType,setRefundtype] = useState('')
    const [refundAmount,setRefundAmount] = useState(null)
    const [openModal,setOpenmodal] = useState(false)
    const [paymentAmount,setPaymentamount] = useState([])
    const [partialRefund,setPartialRefund] = useState([{id:1,amount:''}])
    const [isTransfer,setIstransfer] = useState(false)
    const [totalAmount,setTotalamount] = useState('')
    const [notes,setNotes] = useState('')
    const [loggedInUserId,setLoggedInUserId] = useState(sessionStorage?.getItem('loggedUserId'))
    const [clientAuthInsCurrent,setClientAuthInsCurrent] = useState({})
    const [loggedInUserDetails,setLoggedInUserDetails] = useState(JSON.parse(sessionStorage?.getItem('userLoggedInDetail')))
    const [refundErr,setRefunderr] = useState('')
    const servicetyperef = useRef(null)
    const [paymentAmountPartial,setPaymentamountPartial] = useState([])
    const [requestbtnDisable,setRequestbtnDisable] = useState(false)
    const [transferIolta,setTransferIolta] = useState('')
    const [transferGeneral,setTransferGeneral] = useState('')
    const [isWithdraw,setIsWithdraw] = useState(false)
    const [withdrawAmount,setWithdrawamount] = useState('')
    const [withdrawRemark,setWithdrawRemark] = useState()
    const [multipleRefundCancel,setMultipleRefundcancel] = useState([])
    const [transferError,setTransferError] = useState(false)
    const [withdrawError,setWithdrawError] = useState(false)
    const [transactionStatusState,setTransactionStatusState]=useState("")
    const [insFullModalState,setInsFullModalState]=useState(false);
    const [showScheduledPyaments,setShowScheduledPayments]=useState(false);
    const scrollRef = useRef(null);
    const scrollTopRef = useRef(0);
    const [triggerUpdateApi,setTriggerUpdateApi]=useState(false)
    const [selectedMatterFilter, setSelectedMatterFilter] = useState('');
    const [matterFilterOpen, setMatterFilterOpen] = useState(false);
    const selectedUserRef = useRef(null);
    const loadFederalWayTimeoutRef = useRef(null);
    
    // Update ref when selectedUser changes
    useEffect(() => {
        selectedUserRef.current = selectedUser;
    }, [selectedUser]);
    
    // Handle refresh trigger from RefundNotification
    useEffect(() => {
        if (refundRefreshTrigger > 0 && selectedUserRef.current) {
            // For Federal Way Plaza, use loadFederalWayOrderRecords
            if (subtinentId == 989 || subtinentId == 760) {
                loadFederalWayOrderRecords(selectedUserRef.current);
            } else if (selectedUserRef.current?.primaryEmail) {
                // For other subtenants, use the trigger API mechanism
                setTriggerUpdateApi(true);
            }
        }
    }, [refundRefreshTrigger]); // Only depend on refundRefreshTrigger
    
    // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (loadFederalWayTimeoutRef.current) {
                clearTimeout(loadFederalWayTimeoutRef.current);
            }
        };
    }, []);
    

    // Reverse function to handle reverse button click
    const reverseFunction = async (clientAuthInsVMs) => {
      try {
        setuseLoader(true);
        
        const requestBody = {
          orderId: clientAuthInsVMs?.orderId,
          isRefund: false,
          isActive: true,
          updatedBy: loggedInUserId,
          isReverse: true
        };

        const response = await Services.updateOrderService(requestBody);
        
        if (response?.data) {
          setToast({message: 'Order reversed successfully.', type: 'success'});
          // Refresh user data to show updated status
          if (subtinentId == 989 || subtinentId == 760) {
            loadFederalWayOrderRecords(selectedUser);
          } else {
            get_UserData(selectedUser?.primaryEmail);
          }
        } else {
          setToast({message: 'Failed to reverse order.', type: 'error'});
        }
      } catch (error) {
        setToast({message: 'Error occurred while reversing order.', type: 'error'});
      } finally {
        setuseLoader(false);
      }
    };

    // Helper function to check if reverse button should be shown
    const shouldShowReverseButton = (clientAuthInsVMs) => {
      return clientAuthInsVMs?.paymentTypeId === 4 || clientAuthInsVMs?.paymentTypeId === 1 || clientAuthInsVMs?.paymentTypeId === 6;
    };

    // Helper function to check if reverse button should be disabled
    const isReverseDisabled = (clientAuthInsVMs, service = null) => {
      // Disable if already reversed
      if (clientAuthInsVMs?.isReverse === true) return true;
      
      // Disable if refund is done
      if (clientAuthInsVMs?.isRefund === true) return true;
      
      // Disable if refund request is pending (showing Cancel button)
      if (clientAuthInsVMs?.isRefundRequestInPending === true) return true;
      
      // Disable if any refund is completed (partial or full)
      if (service) {
        const refundedArray = (service?.clientAuthInsVMs || [])?.filter((r) => r.refundBasedOrderId == clientAuthInsVMs?.orderId);
        const refunedAmount = refundedArray?.reduce((a, c) => a + (Number(c.payAmount) || 0), 0) ?? 0;
        if (refunedAmount > 0) {
          return true;
        }
      }
      
      // Note: Reverse button is NOT disabled for transfer or withdraw operations
      // as per requirement to allow reverse during transfer and withdraw
      
      return false;
    };

    // Helper function to check if refund/transfer/withdraw buttons should be disabled due to reverse
    const isActionDisabledDueToReverse = (clientAuthInsVMs) => {
      return clientAuthInsVMs?.isReverse === true;
    };

    
const headerStyle = {
  borderBottom: "1px solid #E5E7EB",
  // paddingLeft: "5px",
  backgroundColor: "#FAFBFF", // optional: improves visual clarity
  fontWeight: 500,         // optional: adds emphasis
  color: "#1A1B1C",
  // borderRight:'3px dotted grey',
  // borderWidth: '5px dotted grey',
  fontFamily: 'Roboto',
  // marginLeft:'2px',
  verticalAlign: "middle",
  padding: "6px",
  textAlign: 'start'
};

const cellStyle = {
  padding: "6px",
  verticalAlign: "middle",
  borderBottom: "1px solid #E5E7EB",
  fontFamily: 'Roboto',
  fontWeight: 400,
  color: '#6B7280',
  // maxWidth:'120px'
};

  const serviceHead = subtinentId == 3 
    ? ['Service Name', 'Total Amount','Payment Type','Payment Date', 'Total Paid', 'Refunded Amount','Status','Action']
    : (subtinentId == 989 || subtinentId == 760)
    ? ['Tenant Name', 'Unit Number', 'Service Name', 'Total Amount','Payment Type','Payment Date', 'Total Paid', 'Refunded Amount','Status','Action']
    : ['Matter no.','Service Name', 'Total Amount','Payment Type','Payment Date', 'Total Paid', 'Refunded Amount','Status','Action']

  useEffect(()=>{
    getServices()
    setPartialRefund([{id:1,amount:''}])
    setPaymentamountPartial([{id:1,amount:''}])
    setTransactionStatusState("")
    window.history.replaceState({}, document.title, "/");
  },[])

  useLayoutEffect(() => {
    if (scrollRef?.current) {
      scrollRef.current.scrollTop = scrollTopRef?.current;
    }
  });

  // console.log("getTransactionStatustefds",transactionStatusState)

    useEffect(()=>{
    const amount = parseFloat(String(withdrawAmount)?.replace(/,/g, ""));
    if(amount == 0 || amount == null || amount == '' || amount == undefined || !amount || Number.isNaN(amount)){
      setWithdrawError(true)
    }else if(parseFloat(String(withdrawAmount)?.replace(/,/g, "")) > parseFloat(String(paymentAmount?.find((f)=> f.AccountTypeId == 2)?.Amount || 0)?.replace(/,/g, ""))){
      setWithdrawError(true)
    }else{
      setWithdrawError(false)
    }
    // console.log(withdrawAmount,"1withdrawAmount",parseFloat(String(withdrawAmount)?.replace(/,/g, "")))

    // else{
    //   setWithdrawError(false)
    // }
  },[withdrawAmount,paymentAmount])

    const setSearchData = (data) => {
      const { memberName, primaryPhoneNumber, primaryEmailAddress, matNo, memberId, clientAuthSubsVMs, loginUserId, contactStatus, registeredOn, primaryUserMemberId, isUserActive, tenantName, unitNumber, clientUserId } = data
      
      // For Federal Way Plaza, use tenantName and unitNumber
      const displayName = (subtinentId == 989 || subtinentId == 760) ? (tenantName || memberName) : memberName;
      const displayMatNo = (subtinentId == 989 || subtinentId == 760) ? (unitNumber || matNo) : matNo;
      
      const matterNumberValue = !isNotValidNullUndefile(displayMatNo)
        ? `${new Date(registeredOn).getFullYear().toString().slice(-2)}-${primaryUserMemberId}`
        : displayMatNo;
        
      setSelecteduser((prev) => ({
        ...prev,
        userId: memberId,
        fullName: displayName,
        primaryEmail: primaryEmailAddress,
        primaryMobile: primaryPhoneNumber,
        memberId: memberId,
        clientAuthSubsVMs: clientAuthSubsVMs,
        matNo: displayMatNo,
        clientUserId: clientUserId,
        contactStatus: contactStatus,
        isUserActive: isUserActive,
        tenantName: tenantName,
        unitNumber: unitNumber,
        tenantId: (subtinentId == 989 || subtinentId == 760) ? data.tenantId : null
      }));
      scrollToSection()
      setSelectedUserData((prev) => ({
        ...prev,
        userId: memberId,
        fullName: displayName,
        primaryEmail: primaryEmailAddress,
        primaryMobile: primaryPhoneNumber,
        memberId: memberId,
        clientUserId: clientUserId,
        tenantName: tenantName,
        unitNumber: unitNumber,
        tenantId: (subtinentId == 989 || subtinentId == 760) ? data.tenantId : null
      }))
      setshowUserForm(true)
      setMatterNumber(displayMatNo); // Adjust based on your data
      setPaymentData({
            ...paymentData,
            ['serviceMatNo']: data?.matNoe
          });
      setShowDropdown(false);
      
      // For Federal Way Plaza, load order records after selecting user
      if (subtinentId == 989 || subtinentId == 760) {
        loadFederalWayOrderRecords(data);
      }
    //   resetToLifepaointdata()
    }

    // Load Federal Way Plaza order records for selected tenant
    const loadFederalWayOrderRecords = (tenantData) => {
      // Clear any existing timeout to debounce rapid calls
      if (loadFederalWayTimeoutRef.current) {
        clearTimeout(loadFederalWayTimeoutRef.current);
      }
      
      // Debounce the API call
      loadFederalWayTimeoutRef.current = setTimeout(() => {
        // console.log("Loading Federal Way Plaza order records for:", tenantData);
        
        // Use tenant name or unit number as search field
        const searchTerm = tenantData.tenantName || tenantData.unitNumber || null;
        
        let inputData = {
          endDate: null,
          isRecordDeatils: null,
          pageNumber: 1,
          rowsOfPage: 40,
          searchField: searchTerm,
          startDate: null,
          subtenantId: subtinentId
        };
        
        // console.log("Federal Way Plaza API input:", inputData);
        setuseLoader(true);
      
      Services?.getCommonApi('POST', AoUrl.getOrderDetailbySubtenantId, inputData)
        .then((res) => {
          if (res?.data?.data && Array.isArray(res.data.data)) {
            // Find records for the selected tenant
            const tenantRecords = res.data.data.filter(item => 
              item && (
                item.tenantName === tenantData.tenantName || 
                item.memberId === tenantData.memberId
              )
            );
            
            if (tenantRecords.length > 0) {
              // Group orders by their relationship (original orders and their refunds)
              const allOrders = tenantRecords.flatMap(record => 
                record.orderDetailsVMs?.map(order => ({
                  ...order,
                  tenantName: record.tenantName,
                  tenantId: record.tenantId
                })) || []
              );
              
              // Separate original orders from refund orders
              const originalOrders = allOrders.filter(order => !order.isRefund);
              const refundOrders = allOrders.filter(order => order.isRefund);
              
              // Transform original orders and attach their refunds
              const transformedRecords = originalOrders.map(order => {
                // Find all refunds for this original order
                const relatedRefunds = refundOrders.filter(refund => 
                  refund.refundBasedOrderId === order.orderId
                );
                
                // Create clientAuthInsVMs array with original order and its refunds
                const clientAuthInsVMs = [
                  // Original order
                  {
                    orderId: order.orderId,
                    payAmount: order.isReverse ? (order.reverseCost || order.totalCost) : order.totalCost,
                    paymentType: order.paymentType,
                    paymentTypeId: order.paymentTypeId,
                    usaPayAmountDate: order.paymentDate,
                    isRefund: false,
                    isReverse: order.isReverse || false,
                    isRefundRequestInPending: order.isRefundRequestInPending || false,
                    refundBasedOrderId: order.refundBasedOrderId,
                    genTransactionId: `FWP_${order.orderId}`,
                    ioltaTransactionId: `FWP_IOLTA_${order.orderId}`,
                    accountType: JSON.stringify([{AccountTypeId: 1, Amount: order.isReverse ? (order.reverseCost || order.totalCost) : order.totalCost}]),
                    orderTransferListVMs: [],
                    orderWithdrawListVMs: [],
                    reverseCost: order.reverseCost,
                    tenantName: order.tenantName,
                    unitNumber: order.unitNumber,
                    tenantId: order.tenantId
                  },
                  // Add refund orders as additional clientAuthInsVMs entries
                  ...relatedRefunds.map(refund => ({
                    orderId: refund.orderId,
                    payAmount: refund.totalCost, // Refund amount
                    paymentType: refund.paymentType,
                    paymentTypeId: refund.paymentTypeId,
                    usaPayAmountDate: refund.paymentDate,
                    isRefund: true,
                    isReverse: false,
                    isRefundRequestInPending: false,
                    refundBasedOrderId: refund.refundBasedOrderId,
                    genTransactionId: `FWP_${refund.orderId}`,
                    ioltaTransactionId: `FWP_IOLTA_${refund.orderId}`,
                    accountType: JSON.stringify([{AccountTypeId: 1, Amount: refund.totalCost}]),
                    orderTransferListVMs: [],
                    orderWithdrawListVMs: [],
                    reverseCost: null,
                    tenantName: refund.tenantName,
                    unitNumber: refund.unitNumber,
                    tenantId: refund.tenantId
                  }))
                ];
                
                return {
                  userAuthSubId: order.orderId,
                  subscriptionId: 1, // Default subscription ID
                  subscriptionName: order.orderProductVMs?.[0]?.productName || 'Federal Way Plaza Service',
                  totalAmount: order.totalCost,
                  serviceMatNo: order.unitNumber,
                  authSubsStartDate: order.paymentDate,
                  clientAuthInsVMs: clientAuthInsVMs
                };
              });
              
              // Update selected user with the order records and ensure tenant info is preserved
              // IMPORTANT: preserve clientUserId and loginUserId from the originally selected tenantData
              // to avoid them being overwritten by a different user's GUID from the reload response
              setSelecteduser(prev => ({
                ...prev,
                clientAuthSubsVMs: transformedRecords,
                tenantName: tenantData.tenantName,
                unitNumber: tenantData.unitNumber || tenantData.matNo,
                tenantId: tenantData.tenantId,
                clientUserId: tenantData.clientUserId || prev.clientUserId,
                memberId: tenantData.memberId || prev.memberId,
              }));
              
              setshowUserForm(false); // Hide the form and show the records
            } else {
              // No records found for this tenant
              setSelecteduser(prev => ({
                ...prev,
                clientAuthSubsVMs: []
              }));
              setshowUserForm(false);
            }
          } else {
            // No data in response
            setSelecteduser(prev => ({
              ...prev,
              clientAuthSubsVMs: []
            }));
            setshowUserForm(false);
          }
          setuseLoader(false);
        })
        .catch((error) => {
          // console.error('Error loading Federal Way order records:', error);
          setuseLoader(false);
        });
      }, 300); // Debounce delay of 300ms
    };

      const runApis = (data, id) => {
        // if (!matterNumber?.trim() && !data?.trim()) return;
        if (!data?.trim()) return;
        
        // Check if it's Federal Way Plaza (989 or 760)
        if (subtinentId == 989 || subtinentId == 760) {
          runFederalWayPlazaApi(data, id);
          return;
        }
        
        let inputData = {
          pageNumber: 1,
          rowsOfPage: 40,
          searchingText: data || null,
          subtenantId: subtinentId || id,
          isTimeMatterClient: null,
        };
        setuseLoader(true)
        Services?.GetClientBySubtenantId(inputData).then((res) => {
          if (res?.data) {
            setResults(res.data?.data || []);
            setShowDropdown(true);
            setuseLoader(false)
            if (res?.data?.data?.length == 0) {
              setshowUserForm(true)
              setSelecteduser(() => ({
                fullName: '',
                primaryEmail: '',
                primaryMobile: '',
                memberId: '',
                matNo: '',
                contactStatus: ''
              }));
              setSelectedUserData()
            }
          }
        })
          .catch((error) => {
            setResults([]);
            setshowUserForm(true)
            setShowDropdown(false);
            setuseLoader(false)
          });
      }

      // Federal Way Plaza specific API call
      const runFederalWayPlazaApi = (data, id) => {
        let inputData = {
          endDate: null,
          isRecordDeatils: null,
          pageNumber: 1,
          rowsOfPage: 40,
          searchField: data || null,
          startDate: null,
          subtenantId: subtinentId || id
        };
        
        setuseLoader(true);
        
        // Call the Federal Way Plaza API
        Services?.getCommonApi('POST', AoUrl.getOrderDetailbySubtenantId, inputData)
          .then((res) => {
            if (res?.data?.data) {
              // Transform and filter the data to match the expected format
              let transformedData = res.data.data.map(item => ({
                memberName: item.tenantName || item.clientName,
                primaryPhoneNumber: item.clientPhoneNo || '',
                primaryEmailAddress: item.clientEmail || '',
                matNo: item.orderDetailsVMs?.[0]?.unitNumber || item.unitNumber,
                memberId: item.memberId,
                clientAuthSubsVMs: item.orderDetailsVMs || [],
                loginUserId: item.clientUserId,
                clientUserId: item.clientUserId,
                contactStatus: 'Active',
                registeredOn: new Date().toISOString(),
                primaryUserMemberId: item.memberId,
                isUserActive: true,
                tenantName: item.tenantName,
                unitNumber: item.orderDetailsVMs?.[0]?.unitNumber || item.unitNumber,
                // Ensure tenantId is properly set from the API response
                // Use the correct tenantId from orderDetailsVMs if available, otherwise use item.tenantId
                tenantId: item.orderDetailsVMs?.[0]?.tenantId || item.tenantId
              }));
              
              // Filter results based on search term (tenant name or unit number)
              if (data && data.trim()) {
                const searchTerm = data.toLowerCase().trim();
                transformedData = transformedData.filter(item => {
                  const tenantName = (item.tenantName || '').toLowerCase();
                  const unitNumber = (item.unitNumber || '').toLowerCase();
                  return tenantName.includes(searchTerm) || unitNumber.includes(searchTerm);
                });
              }
              
              setResults(transformedData);
              setShowDropdown(true);
              setuseLoader(false);
              
              if (transformedData.length == 0) {
                setshowUserForm(true);
                setSelecteduser(() => ({
                  fullName: '',
                  primaryEmail: '',
                  primaryMobile: '',
                  memberId: '',
                  matNo: '',
                  contactStatus: ''
                }));
                setSelectedUserData();
              }
            }
          })
          .catch((error) => {
            // console.error('Federal Way Plaza API Error:', error);
            setResults([]);
            setshowUserForm(true);
            setShowDropdown(false);
            setuseLoader(false);
          });
      }

       const getClientListApiFunc = async() => {
        let inputData = {
          pageNumber: 1,
          rowsOfPage: 40,
          subtenantId: subtinentId,
          isTimeMatterClient: null
        };
        setuseLoader(true)
        const _resultOf = await Services.GetClientDetailsByUserId(inputData,selectedUser?.userId);
        try{
          if (_resultOf != 'err' && _resultOf?.data?.length > 0) {
            const resData = _resultOf?.data[0];
            // console.log("brvf",resData)
          }
          setuseLoader(false)
        }catch(err){
          setuseLoader(false)
        }
      }



      const updateUser = (data, formJson, timeMatter) => {
        const { createdBy, emailId, firstName, lastName, userId, contactStatus } = data?.data?.data
        let inputData = {
          fName: firstName,
          lName: lastName ?? '',
          mName: "",
          isPrimaryMember: true,
          subtenantId: subtinentId,
          updatedBy: createdBy,
          userId: userId,
          memberRelationship: null,
          matNo: formJson?.matno,
          contactStatus: contactStatus
        }
      
        const updateUser = Services?.upateMemberByuserID(inputData)
        updateUser.then((res) => {
          get_UserData(emailId, timeMatter)
          sessionStorage.removeItem('userRegistration');
          sessionStorage.setItem("userRegistred", true);
          sessionStorage.setItem("SessPrimaryUserId", userId);
        }).catch((err) => {
          console.log(err, "err")
        })
      }

      const get_UserData = (matterNumber, timeMatter) => {
        let inputData = {
          pageNumber: 1,
          rowsOfPage: 40,
          searchingText: matterNumber || null,
          subtenantId: subtinentId,
          isTimeMatterClient: null
        };
        setuseLoader(true)
        Services?.getUserByName(inputData).then((res) => {
          if (res?.data) {
            setResults(res.data?.data || []);
            setSearchData(res.data?.data[0])
            setuseLoader(false)
          }
        })
          .catch((error) => {
            setResults([]);
            setShowDropdown(false);
            setuseLoader(false)
          });
      }

    const refundFunction = async (service,clientAuthInsVMs) => {
      // console.log("Federal Way Plaza Refund Function Called:", {service, clientAuthInsVMs, subtinentId});
      
      let clientAuthInsVmsData = clientAuthInsVMs != undefined ? clientAuthInsVMs : (service?.clientAuthInsVMs || [])[0]
      let accountTypearray = clientAuthInsVmsData?.accountType != null ? JSON.parse(clientAuthInsVmsData?.accountType) : [{AccountTypeId:1,Amount:clientAuthInsVmsData?.payAmount}]
      
      // console.log("Federal Way Plaza clientAuthInsVmsData:", clientAuthInsVmsData);
      // console.log("Federal Way Plaza accountTypearray:", accountTypearray);
      
      // Skip transaction status check for Federal Way Plaza (989, 760)
      let getTransactionStatus = true;
      if (subtinentId != 989 && subtinentId != 760) {
        getTransactionStatus = (accountTypearray?.some(e=> e.AccountTypeId == 1) && clientAuthInsVmsData?.paymentTypeId == 1) ? await getTransactionStatusfunc(clientAuthInsVmsData?.genTransactionId) : true;
      }
      
      // console.log("Federal Way Plaza getTransactionStatus:", getTransactionStatus);
      
      if(getTransactionStatus== false){
        return setToast({message:'Refund cannot be processed as the transaction is not found.',type:'error'})
      }else{
      let totalPaid = (service?.clientAuthInsVMs || [])?.filter(r=>r.isRefund != true)?.reduce((a, c) => { return a + c.payAmount }, 0) || 0
      
      // console.log("Federal Way Plaza totalPaid:", totalPaid);
      // console.log("Federal Way Plaza opening modal...");
      
      setServiceType(service.subscriptionId)
      setOrderdetails(service)
      setRefundtype('Yes')
      setOpenmodal(true)
      if((service?.clientAuthInsVMs || [])[0]?.accountType != null){
        setPaymentamount(JSON.parse((service?.clientAuthInsVMs || [])[0]?.accountType))
      }else{
        setPaymentamount([{AccountTypeId:1,Amount:totalPaid}])
      }
      setPartialRefund([{id:1,amount:''}])
      setIstransfer(false)
      setTotalamount(totalPaid)
      if(clientAuthInsVMs != undefined){
        setRefundAmount(clientAuthInsVMs?.payAmount || null)
        setTotalamount(clientAuthInsVMs?.payAmount)
        if(clientAuthInsVMs?.accountType != null){
          setPaymentamount(JSON.parse(clientAuthInsVMs?.accountType))
        }else{
          setPaymentamount([{AccountTypeId:1,Amount:clientAuthInsVMs?.payAmount}])
        }
        setClientAuthInsCurrent(clientAuthInsVMs)
      }else{
        setClientAuthInsCurrent((service?.clientAuthInsVMs || [])[0])
        setRefundAmount(totalPaid || null)
      }
      }
      setNotes('')
      setIstransfer(false)
      setIsWithdraw(false)
      setRefunderr('')
      
      // console.log("Federal Way Plaza refund function completed, modal should be open");
    }

    const TransferFunction = (service,clientAuthInsVMs) => {
      // console.log(service,"serviceservice",clientAuthInsVMs)
      let totalPaid = (service?.clientAuthInsVMs || [])?.filter(r=>r.isRefund != true)?.reduce((a, c) => { return a + c.payAmount }, 0) || 0
      setServiceType(service.subscriptionId)
      setOrderdetails(service)
      // setRefundAmount(totalPaid)
      // setRefundtype('Yes')
      setOpenmodal(true)
      setIstransfer(true)
      setIsWithdraw(false)
      setNotes('')
      if(clientAuthInsVMs != undefined){
        setClientAuthInsCurrent(clientAuthInsVMs)
        if(clientAuthInsVMs?.accountType != null){
          setPaymentamount(JSON.parse(clientAuthInsVMs?.accountType))
        }else{
          setPaymentamount([{AccountTypeId:1,Amount:clientAuthInsVMs?.payAmount}])
        }
        setTotalamount(clientAuthInsVMs?.payAmount)
      }else{
        setClientAuthInsCurrent((service?.clientAuthInsVMs || [])[0])
        setTotalamount(totalPaid)
        if((service?.clientAuthInsVMs || [])[0]?.accountType != null){
          setPaymentamount(JSON.parse((service?.clientAuthInsVMs || [])[0]?.accountType))
        }else{
          setPaymentamount([{AccountTypeId:1,Amount:totalPaid}])
        }
      }
      setTransferGeneral('')
      setTransferIolta('')
      // setPartialRefund([{id:1,amount:''}])
    }

    const withdrawFunction = (service,clientAuthInsVMs) => {
      // console.log(service,"serviceservice")
      let totalPaid = (service?.clientAuthInsVMs || [])?.filter(f => f.isRefund != true)?.reduce((a, c) => { return a + c.payAmount }, 0) || 0
      setServiceType(service?.subscriptionId)
      setOrderdetails(service)
      if(clientAuthInsVMs != undefined){
        setClientAuthInsCurrent(clientAuthInsVMs)
        if(clientAuthInsVMs?.accountType != null){
          setPaymentamount(JSON.parse(clientAuthInsVMs?.accountType))
        }else{
          setPaymentamount([{AccountTypeId:1,Amount:clientAuthInsVMs?.payAmount}])
        }
        setTotalamount(clientAuthInsVMs?.payAmount)
      }else{
        setClientAuthInsCurrent((service?.clientAuthInsVMs || [])[0])
        setTotalamount(totalPaid)
        if((service?.clientAuthInsVMs || [])[0]?.accountType != null){
          setPaymentamount(JSON.parse((service?.clientAuthInsVMs || [])[0]?.accountType))
        }else{
          setPaymentamount([{AccountTypeId:1,Amount:totalPaid}])
        }
      }
      setOpenmodal(true)
      setIsWithdraw(true)
      setIstransfer(false)
      // setTotalamount(totalPaid)
      setNotes('')
      setWithdrawRemark('')
      setWithdrawamount('')
    }

  const getTransactionStatusfunc = async (transactionId) => {
    let checkTransactionStatusrResponse = await Services?.checkTransactionStatusrService(transactionId)
    if(checkTransactionStatusrResponse != 'err'){
      // console.log(checkTransactionStatusrResponse?.data?.data?.transactionStatus,"checkTransactionStatusrResponse")
      checkTransactionStatusrResponse= checkTransactionStatusrResponse?.data?.data?.transactionStatus
      // console.log("yrbgtfd",checkTransactionStatusrResponse)
      setTransactionStatusState(checkTransactionStatusrResponse)
      return (checkTransactionStatusrResponse== 'settledSuccessfully' || checkTransactionStatusrResponse== 'capturedPendingSettlement' ) ? true : false
    }else{
      return false
    }
  }

    const getServices = () => {
      setuseLoader(true)
      const result = Services?.getUserServices(subtinentId).then((res) => {
        if (res) {
          let filteredData = res?.data?.data?.sort((a, b) => {
            if (a.subscriptionId == 9) return 1;
            if (b.subscriptionId == 9) return -1;
            return 0;
          });
          setService(filteredData)
          setuseLoader(false)
        }
      }).catch((err) => {
        setuseLoader(false)
      })
    }

  const radioButton = (label, value, state, setState) => {
  // console.log(issplitPaymentSession,"issplitPaymentSession")
  return <label class="radio-label custom-radio">
    <input type="radio" name={label} value={value} checked={state == value} onChange={(e) => {setState(e.target.value)}} />
    {/* <div class="w-4 h-4 rounded-full border-2 border-gray-400 peer-checked:border-blue-600 peer-checked:bg-blue-600 transition"></div> */}
    <span class="ml-2 text-gray-700">{label}</span>
  </label>
}

  useEffect(()=>{
    if(refundType == 'No'){
      setRefundAmount(null)
      setPaymentamountPartial([{id:1,amount:''}])
      // setPaymentamount([])
    }else{
      let totalPaid = (orderDetails?.clientAuthInsVMs || [])?.filter(r=>r.isRefund != true)?.reduce((a, c) => { return a + c.payAmount }, 0) || 0
      const refundedArray = (orderDetails?.clientAuthInsVMs || [])?.filter((r)=> r.refundBasedOrderId == clientAuthInsCurrent?.orderId) || []
      const refunedAmount = refundedArray?.reduce((a, c) => a + (Number(c.payAmount) || 0), 0) ?? 0;
      // console.log(refundedArray,'refundedArray',refunedAmount,"rowsrows",service?.clientAuthInsVMs)
      // let newPayamount = (refundedArray?.length > 0 && refunedAmount != undefined) ? (totalPaid) - (refunedAmount) : clientAuthInsCurrent?.payAmount
      // console.log(totalPaid,"totalPaidtotalPaidtotalPaidtotalPaidrefundedArray",orderDetails?.clientAuthInsVMs,"newPayamount",newPayamount,"refundedArray",refundedArray,"refunedAmount",refunedAmount,"clientAuthInsCurrent",clientAuthInsCurrent)
      setRefundAmount(totalAmount || null)
      // Clear any existing refund errors when switching to full refund
      setRefunderr('')
      // setPaymentamount([{AccountTypeId:1,Amount:newPayamount}])
    }
  },[refundType])

  const chackboxButtonAccount = (label, value, data, setData, isDisabled) => {
  const entry = data?.length > 0 && data?.find((item) => item.AccountTypeId === value);
  const isChecked = !!entry;

  const handleCheckboxChange = (e) => {
    if (e.target.checked) {
      setData([...data, { AccountTypeId: value, Amount: '' }]);
    } else {
      setData(data?.filter((item) => item.AccountTypeId !== value));
    }
  };

  const handleInputChange = (e) => {
    // console.log(e.target.value,"etargetvalue")
    if(e.target.value == ' ') return
    const newData = data?.length > 0 && data?.map((item) =>
      item.AccountTypeId === value ? { ...item, Amount: (e.target.value)?.replace(/,/g, "") } : item
    );
    let calculateTotal = newData.reduce((a, c) => Number(a) + parseFloat(String(c.Amount)?.replace(/,/g, "")) , 0)
    // let tAmount = PaymentOption == 1 ? paymentData?.amount : paymentData?.payAmount
    // if (calculateTotal > parseFloat(String(tAmount)?.replace(/,/g, ""))) {
    //   setToast({ message: 'Please enter a valid amount.', type: 'error' });
    //   return
    // }
    setData(newData);
  };


  return (
    <>
    <div className="mb-2 flex items-center space-x-3 w-100">
      <label className="flex items-center">
        <input
          type="checkbox"
          value={value}
          checked={isChecked}
          onChange={handleCheckboxChange}
          className="mr-2 bg-gray-200"
          disabled={refundType == 'Yes' || isTransfer == true || isDisabled == true ? true : false}
        />
        <span>{label}</span>
      </label>
      {isChecked && (
        <div className="relative w-20">
          <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
            <span className="text-gray-500">$</span>
          </div>
          <input
            type="input"
            value={formatToUS(entry?.Amount?.toString()) || ''}
            onChange={handleInputChange}
            placeholder="0"
            // min="0"
            // step="1"
            className={`w-20 border border-gray-300 rounded-md px-2 py-2 pl-5 ${refundType == 'Yes' || isTransfer == true || isDisabled == true ? 'bg-gray-200' : '!bg-[#ffffff]'}`}
            disabled={refundType == 'Yes' || isTransfer == true || isDisabled == true ? true : false}
          />
        </div>
      )}
    </div>
    </>
  );
};

 const updateAddUserAuthSubsInsfunc = async (service,json) => {
  // Skip AddUserAuthSubsIns API call for Federal Way Plaza as it's not needed
  if (subtinentId == 989 || subtinentId == 760) {
    // console.log("Federal Way Plaza: Skipping AddUserAuthSubsIns API call");
    return { data: { data: null } }; // Return empty response to maintain flow
  }
  
  let jsonObj = [
  {
    "authSubInstallmentId": 0,
    "orderId": service?.orderId,
    "payAmount": refundAmount,
    "notes": notes,
    "isActive": true,
    "isScheduledPayment": false,
    "userAuthSubId": json?.userAuthSubId,
    "createdBy": loggedInUserId
  }
]
  setuseLoader(true)
  let installmentResponse = await Services.postAddUserAuthSubsInsService(jsonObj)
  setuseLoader(false)
  if(installmentResponse != 'err'){
    return installmentResponse?.data?.data
  }

 }

 const postcreaterequestfunc = async (orderId, amount, originalOrderId) => {
  if (!orderId) {
    // console.error("ERROR: Missing orderId");
    setToast({message:'Missing order ID for refund request.',type:'error'})
    return;
  }
  
  if (!selectedUser?.userId && !selectedUser?.clientUserId && !selectedUser?.memberId) {
    setToast({message:'Missing user information for refund request.',type:'error'})
    return;
  }
  
  if (!subtinentId) {
    // console.error("ERROR: Missing subtinentId");
    setToast({message:'Missing company information for refund request.',type:'error'})
    return;
  }
  
  // For Federal Way Plaza, use clientUserId (GUID) instead of userId (number)
  let requestByValue = selectedUser?.userId;
  if (subtinentId == 989 || subtinentId == 760) {
    requestByValue = selectedUser?.clientUserId || selectedUser?.userId;
  }
  
  let json = [
  {
    "subtenantId": subtinentId,
    "refundOrderId": orderId,
    "requestBy": requestByValue,
    "notes": subtinentId == 989 || subtinentId == 760 
      ? `Unit: ${selectedUser?.unitNumber || selectedUser?.matNo || 'N/A'}${notes ? ` | ${notes}` : ''}` 
      : (notes || ""),
    // For Federal Way Plaza, include tenantId and additional fields
    ...(subtinentId == 989 || subtinentId == 760 ? {
      "tenantId": selectedUser?.tenantId || null,
      "seriveMatNo": selectedUser?.unitNumber || selectedUser?.matNo,
      "tenantName": selectedUser?.tenantName || selectedUser?.fullName
    } : {})
  }]
  
  // console.log("Federal Way Plaza postcreaterequestfunc JSON:", json);
  
  setuseLoader(true)
  try {
    let postcreaterequestresponse = await Services?.postcreaterequestService(json)
    setuseLoader(false)
    
    if(postcreaterequestresponse && postcreaterequestresponse != 'err'){
      // console.log("Federal Way Plaza refund request successful:", postcreaterequestresponse);
      
      // For Aging Options (subtinentId == 3) and Federal Way Plaza (989, 760), set isRefundRequestInPending to true
      if (subtinentId == 3 || subtinentId == 989 || subtinentId == 760) {
        updateRefundRequestPendingStatus(originalOrderId || clientAuthInsCurrent?.orderId, true);
      }
      
      return postcreaterequestresponse;
    } else {
      // console.error("ERROR: API returned error or null:", postcreaterequestresponse)
      setToast({message:'Failed to create refund request. Please try again.',type:'error'})
    }
  } catch (error) {
    // console.error("EXCEPTION in postcreaterequestfunc:", error);
    setuseLoader(false)
    setToast({message:'Error occurred while creating refund request.',type:'error'})
  }
 }

 const submitData = async () =>{
  // console.log("Federal Way Plaza submitData called with:", {refundAmount, totalAmount, refundType, paymentAmount, paymentAmountPartial});
  
  try {
    if(refundAmount > totalAmount){
      setToast({message:'Refund amount must be less than Paid amount.',type:'error'})
      return;
    }

    let paymentTypeArray = refundType == 'Yes' ? paymentAmount : paymentAmountPartial
    
    // console.log("Federal Way Plaza initial paymentTypeArray:", paymentTypeArray);
    
    // For Aging Options (subtinentId == 3) and Federal Way Plaza (989, 760), handle payment arrays differently
    if (subtinentId == 3 || subtinentId == 989 || subtinentId == 760) {
      // console.log("Federal Way Plaza: Using simplified payment array logic");
      if (refundType == 'Yes') {
        // Full refund - if paymentAmount is empty, create it from refundAmount
        if (!paymentAmount || paymentAmount.length === 0) {
          if (refundAmount && refundAmount > 0) {
            paymentTypeArray = [{AccountTypeId: 1, Amount: parseFloat(String(refundAmount)?.replace(/,/g, ""))}];
          } else {
            paymentTypeArray = [];
          }
        } else {
          paymentTypeArray = paymentAmount;
        }
      } else {
        // Partial refund - create a simple array with the refund amount
        if (refundAmount && refundAmount > 0) {
          paymentTypeArray = [{AccountTypeId: 1, Amount: parseFloat(String(refundAmount)?.replace(/,/g, ""))}];
        } else {
          paymentTypeArray = [];
        }
      }
    }
    
    // console.log("Federal Way Plaza final paymentTypeArray:", paymentTypeArray);
    
    if (!paymentTypeArray || paymentTypeArray.length === 0) {
      console.error("Federal Way Plaza: No payment information found");
      setToast({message:'No payment information found for refund.',type:'error'})
      return;
    }
    
    // console.log("Federal Way Plaza: Processing refund for", paymentTypeArray.length, "payment items");
    
    for(let i = 0; i < paymentTypeArray.length; i++){
      let item = paymentTypeArray[i];
      // console.log("Federal Way Plaza: Processing payment item", i, ":", item);
      await refundSubmitApis(item)
    }
    
    // console.log("Federal Way Plaza: All refund requests completed");
    setToast({message:'Refund request generated successfully.',type:'success'})
    
    // For Aging Options (subtinentId == 3) and Federal Way Plaza (989, 760), refresh user data to show updated status
    if (subtinentId == 3) {
      // Small delay to ensure backend has processed the request
      setTimeout(() => {
        get_UserData(selectedUser?.primaryEmail);
      }, 1000);
    } else if (subtinentId == 989 || subtinentId == 760) {
      // For Federal Way Plaza, refresh using the specific API
      setTimeout(() => {
        loadFederalWayOrderRecords(selectedUser);
      }, 1000);
    }
    
    // Reset form data
    setSelectedUserData({
      fullName: '',
      primaryEmail: '',
      primaryMobile: '',
      memberId: '',
      matNo:''
    })
    setSelecteduser({
      fullName: '',
      primaryEmail: '',
      primaryMobile: '',
      memberId: '',
      matNo:''
    })
    sessionStorage.removeItem('userDeatils')
    setOpenmodal(false)
    setSelecteduser('')
    
  } catch (error) {
    // console.error("EXCEPTION in Federal Way Plaza submitData:", error);
    setToast({message:'Failed to process refund request.',type:'error'})
  }
 }



 const refundSubmitApis = async (paymentAccount) => {
  // console.log("Federal Way Plaza refundSubmitApis called with:", {paymentAccount, orderDetails, selectedUser, clientAuthInsCurrent});
  
  if(paymentAccount?.Amount == 0 || paymentAccount?.Amount == null || paymentAccount?.Amount == undefined) {
    // console.log("Federal Way Plaza: Payment amount is 0 or null, skipping");
    return;
  }
  
  // Create proper user structure for Federal Way Plaza
  let federalWayUser = selectedUser;
  if (subtinentId == 989 || subtinentId == 760) {
    
    // Create a proper user structure that addOrderUser expects
    federalWayUser = {
      userId: selectedUser?.clientUserId || selectedUser?.memberId,
      memberId: selectedUser?.memberId || selectedUser?.clientUserId,
      fullName: selectedUser?.tenantName || selectedUser?.fullName,
      primaryEmail: selectedUser?.primaryEmail || '',
      primaryMobile: selectedUser?.primaryMobile || '',
      matNo: selectedUser?.unitNumber || selectedUser?.matNo,
      clientUserId: selectedUser?.clientUserId,
      contactStatus: selectedUser?.contactStatus || 'Active',
      isUserActive: selectedUser?.isUserActive !== false,
      tenantName: selectedUser?.tenantName || selectedUser?.fullName,
      unitNumber: selectedUser?.unitNumber || selectedUser?.matNo,
      tenantId: selectedUser?.tenantId
    };
    
    console.log("Federal Way Plaza Debug - selectedUser.memberId:", selectedUser?.memberId);
    console.log("Federal Way Plaza Debug - federalWayUser.memberId:", federalWayUser.memberId);
    
    // console.log("Federal Way Plaza federalWayUser:", federalWayUser);
  }
  
  // Standard flow for all subtenants (including Federal Way Plaza)
  let json = { 
    lineOfBusiness: Number(orderDetails?.subscriptionId) || 1, 
    userAuthSubId: orderDetails?.userAuthSubId, 
    payAmount: paymentAccount?.Amount, 
    amount: paymentAccount?.Amount, 
    serviceName: orderDetails?.subscriptionName || ((subtinentId == 989 || subtinentId == 760) ? 'Federal Way Plaza Service' : orderDetails.subscriptionName), 
    totalDiscount: 0,
    sourceType: orderDetails?.sourceTypeId || 1,
    isRefund: true,
    refundBasedOrderId: clientAuthInsCurrent?.orderId,
    paymentTypeId: paymentAccount?.AccountTypeId == 2 ? 4 : clientAuthInsCurrent?.paymentTypeId,
    AccountType: [paymentAccount]
  }
  
  // console.log("Refund JSON:", json);
  
  try {
    // console.log("Calling addOrderUser...");
    
    // Use the proper user structure for Federal Way Plaza
    // For Federal Way Plaza, we need to pass the federalWayUser data as selectedUserData to generateOrderJson
    const userForOrder = (subtinentId == 989 || subtinentId == 760) ? federalWayUser : selectedUser;
    let addOrderresponse = await addOrderUser(userForOrder, json)
    // console.log("addOrderUser response:", addOrderresponse);
    
    if (!addOrderresponse || !addOrderresponse.orderId) {
      // console.error("Failed to create refund order", addOrderresponse);
      setToast({message:'Failed to create refund order.',type:'error'})
      return;
    }
    
    // console.log("Calling updateAddUserAuthSubsInsfunc...");
    await updateAddUserAuthSubsInsfunc(addOrderresponse, json)
    
    // console.log("Calling postcreaterequestfunc...");
    await postcreaterequestfunc(addOrderresponse?.orderId, paymentAccount?.Amount, clientAuthInsCurrent?.orderId)
    
    // console.log("Refund request completed successfully");
    
  } catch (error) {
    // console.error("EXCEPTION in refundSubmitApis:", error);
    setToast({message:'Error processing refund request.',type:'error'})
  }
 }

 const refundInput = (e) => {
  // console.log(e.target.value,totalAmount,"totalAmounttotalAmount")
  
  if(parseFloat(String(e.target.value)?.replace(/,/g, "")) > parseFloat(String(totalAmount)?.replace(/,/g, ""))){
    setRefunderr(`Partial amount cannot exceed $${totalAmount}.`)
  }else{
    setRefunderr('')
  }
  setRefundAmount(e.target.value);
  // console.log(e.target.value,paymentAmount?.find((f)=> f.AccountTypeId == 1)?.Amount,"djskjdksdjks")
 }

  useEffect(() => {
    const generalAvailable =
      parseFloat(String(paymentAmount?.find(f => f.AccountTypeId == 1)?.Amount ?? 0)?.replace(/,/g, ""));
    
    const ioltaAvailable =
      parseFloat(String(paymentAmount?.find(f => f.AccountTypeId == 2)?.Amount ?? 0)?.replace(/,/g, ""));

    setPaymentamountPartial(prev => {

      // console.log(parseFloat(String(refundAmount)?.replace(/,/g, "")), generalAvailable,"refundAmountgeneralAvailable")
      const generalAmount = Math.min(parseFloat(String(refundAmount)?.replace(/,/g, "")), generalAvailable);
      
      const ioltaAmount = ioltaAvailable > 0 ? parseFloat(String(refundAmount)?.replace(/,/g, ""))  - generalAmount : 0;
      
      // console.log(generalAmount,ioltaAmount,"generalAmountioltaAmount")
      let returnArray = []
      
      if(generalAmount > 0){
        returnArray.push({AccountTypeId: 1, Amount: generalAmount })
      }
      if(ioltaAmount > 0 && ioltaAvailable > 0){
        returnArray.push({ AccountTypeId: 2, Amount: ioltaAmount })
      }

      return returnArray;
    });
  }, [refundAmount, paymentAmount]);

  useEffect(()=>{
    // For Aging Options (subtinentId == 3) and Federal Way Plaza (989, 760), use simplified logic
    if(subtinentId == 3 || subtinentId == 989 || subtinentId == 760) {
      if(refundType == 'Yes') {
        // Full refund - always enable
        setRequestbtnDisable(false)
      } else {
        // Partial refund - enable only when amount is entered
        if(refundAmount == 0 || refundAmount == null || refundAmount == ''){
          setRequestbtnDisable(true)
        } else {
          setRequestbtnDisable(false)
        }
      }
    } else {
      // Original logic for other companies
      if(refundAmount == 0 || refundAmount == null || refundAmount == ''){
        setRequestbtnDisable(true)
      }else if(parseFloat(paymentAmountPartial?.reduce((a,c)=> a + parseFloat(String(c.Amount || 0)?.replace(/,/g, "")), 0)) > parseFloat(String(refundAmount)?.replace(/,/g, ""))){
        
        setRequestbtnDisable(true)
      }else if(parseFloat(paymentAmountPartial?.reduce((a,c)=> a + parseFloat(String(c.Amount || 0)?.replace(/,/g, "")), 0)) < parseFloat(String(refundAmount)?.replace(/,/g, ""))){
        
        setRequestbtnDisable(true)
      }else if(parseFloat(String(paymentAmount?.find((f)=> f.AccountTypeId == 2)?.Amount || 0)?.replace(/,/g, "")) < parseFloat(paymentAmountPartial?.find((f)=> f.AccountTypeId == 2)?.Amount)){
        setRequestbtnDisable(true)
      }else if(parseFloat(String(paymentAmount?.find((f)=> f.AccountTypeId == 1)?.Amount || 0)?.replace(/,/g, "")) < parseFloat(paymentAmountPartial?.find((f)=> f.AccountTypeId == 1)?.Amount)){
        setRequestbtnDisable(true)
      }else{
        
        setRequestbtnDisable(false)
      }
    }
  },[refundAmount,paymentAmountPartial,refundType,subtinentId])


 useEffect(() => {
  const getAmount = (id) =>
    parseFloat(
      String(paymentAmount?.find(f => f.AccountTypeId == id)?.Amount || 0)
        .replace(/,/g, "")
    );

  const generalReceived = getAmount(1);
  const ioltaReceived = getAmount(2);

  const transferIoltaAmount = parseFloat(String(transferIolta)?.replace(/,/g, "")) || 0;
  const transferGeneralAmount = parseFloat(String(transferGeneral)?.replace(/,/g, "")) || 0;

  let isError = false;

  if (transferIoltaAmount === 0 && transferGeneralAmount === 0) {
    isError = true;
  }

  if (transferIoltaAmount > 0) {
    if (transferIoltaAmount > generalReceived) {
      isError = true;
    }
  }

  if (transferGeneralAmount > 0) {
    if (transferGeneralAmount > ioltaReceived) {
      isError = true;
    }
  }

  setTransferError(isError);

}, [transferIolta, transferGeneral, paymentAmount]);

// console.log(transferError,"transferError")
  const scrollToSection = () => {
    if (servicetyperef.current != null) {
      setTimeout(()=>{
      servicetyperef?.current?.scrollIntoView({ behavior: 'smooth' });
      },100)
    }
  };

    function formatToUS(value) {
    // console.log(value,"valuevaluevaluevaluevalue")
    if (!value) return "";
    let cleaned = value?.replace(/,/g, "");

    if (!/^\d*\.?\d{0,2}$/.test(cleaned)) {
      return null;
    }

    const parts = cleaned.split(".");
    let integerPart = parts[0];
    const decimalPart = parts[1] !== undefined ? parts[1] : null;

    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if (decimalPart === null) {
      return integerPart;
    } else {
      return integerPart + "." + decimalPart;
    }
  }

  const calculateAccountTypediffrence = (array1,refundArray) => {
    const allAccountTypes = refundArray?.flatMap(item =>
    item?.accountType != null && JSON.parse(item?.accountType)?.map(acc => ({
      ...acc,
      Amount: parseFloat(String(acc.Amount || 0)?.replace(/,/g, ""))
    }))
    );

    let combinedArray = Object.values(
  allAccountTypes.reduce((acc, curr) => {
    if (acc[curr.AccountTypeId]) {
      acc[curr.AccountTypeId].Amount += curr.Amount; // sum Amount
    } else {
      acc[curr.AccountTypeId] = { ...curr }; // copy new entry
    }
    return acc;
  }, {})
);



    let arr1 = JSON?.parse(array1)
    let arr2 = combinedArray
    // console.log(arr1,"calculateAccountTypediffrence",arr2,"refundArray",refundArray,allAccountTypes,"combinedArray",combinedArray)

    let returnArr = [];
    let generalAmount = parseFloat(String(arr1?.find(f=> f.AccountTypeId == 1)?.Amount)?.replace(/,/g, "")) - parseFloat(String(arr2?.find(f=> f.AccountTypeId == 1)?.Amount || 0)?.replace(/,/g, ""))
    let ioltaAmount = parseFloat(String(arr1?.find(f=> f.AccountTypeId == 2)?.Amount)?.replace(/,/g, "")) - parseFloat(String(arr2?.find(f=> f.AccountTypeId == 2)?.Amount || 0)?.replace(/,/g, ""))
    if(generalAmount > 0){
    returnArr.push({AccountTypeId:1,Amount:generalAmount})
    }
    if(ioltaAmount > 0){
    returnArr.push({AccountTypeId:2,Amount:ioltaAmount})
    }
    // console.log(returnArr,"returnArr")
    return returnArr;
  }
  
  const onCancelRefund = async (orderId) => {
    const getRefundDetails = await getRefundrequestfunc(orderId)
    // console.log(getRefundDetails,"getRefundDetailsorderId",orderId)
    if(getRefundDetails?.length > 1){
      setMultipleRefundcancel(getRefundDetails)
    }else{
      await updateRefundrequestFunc(getRefundDetails[0],4)
      setToast({message:'Refund request cancelled successfully.',type:'success'})
      
      // For Aging Options (subtinentId == 3) and Federal Way Plaza (989, 760), update local state
      if (subtinentId == 3) {
        updateRefundRequestPendingStatus(orderId, false);
        get_UserData(selectedUser?.primaryEmail);
      } else if (subtinentId == 989 || subtinentId == 760) {
        updateRefundRequestPendingStatus(orderId, false);
        // For Federal Way Plaza, refresh using the specific API
        setTimeout(() => {
          loadFederalWayOrderRecords(selectedUser);
        }, 500);
      }
    }
  }

  // Function to update isRefundRequestInPending status in local data
  const updateRefundRequestPendingStatus = (orderId, isPending) => {
    setSelecteduser(prevUser => {
      if (!prevUser?.clientAuthSubsVMs) return prevUser;
      
      const updatedClientAuthSubsVMs = prevUser.clientAuthSubsVMs.map(service => {
        if (!service?.clientAuthInsVMs) return service;
        
        const updatedClientAuthInsVMs = service.clientAuthInsVMs.map(authIns => {
          if (authIns.orderId === orderId) {
            return {
              ...authIns,
              isRefundRequestInPending: isPending
            };
          }
          return authIns;
        });
        
        return {
          ...service,
          clientAuthInsVMs: updatedClientAuthInsVMs
        };
      });
      
      return {
        ...prevUser,
        clientAuthSubsVMs: updatedClientAuthSubsVMs
      };
    });
  };
  // console.log(selectedUser,"selectedUser")

    const getRefundrequestfunc = async (orderId) => {
      // console.log(orderId,"orderIdorderId")
    let json = {
      "statusId": 1,
      "isActive": true,
      "subtenantId": subtinentId, // Use the current subtenant ID instead of hardcoded 2
      "refundBasedOrderId": orderId,
      "pageNumber": 1,
      "rowsOfPage": 40
    }
    setuseLoader(true)
    let getRefundrequestresponse = await Services.getRefundrequestService(json)
    setuseLoader(false)
    if(getRefundrequestresponse != 'err'){
      return getRefundrequestresponse?.data?.data
      // console.log(getRefundrequestresponse,"getRefundrequestresponse")
      // setNotifyarray(prev => [
      //   ...prev,
      //   ...(getRefundrequestresponse?.data?.data || [])
      // ]);
    }
  }



  const updateRefundrequestFunc = async (data,status) => {
    let jsonObj = [{
      "refReqId": data?.refReqId,
      "statusId": status,
      "accpetBy": loggedInUserId,
      "isActive": true
    }]
    // console.log(data,"datadata",status)
    setuseLoader(true)
    let updateRefundrequestparams = await Services?.updateRefundrequestService(jsonObj);
    setuseLoader(false)
    if(updateRefundrequestparams != 'err'){
      // console.log(updateRefundrequestparams,"updateRefundrequestparams")
      // setToast({ message: `Refund request is ${status == 2 ? 'accepted' : 'declined'} successfully.`, type: "success" });
      // if(status == 3){
      // getRefundrequestfunc();
      // }
    }
  }

  const cancelMultipleRefund = async (refundDetails) => {
      await updateRefundrequestFunc(refundDetails,4)
      setMultipleRefundcancel([])
      setToast({message:'Refund request cancelled successfully.',type:'success'})
      
      // For Aging Options (subtinentId == 3) and Federal Way Plaza (989, 760), update local state
      if (subtinentId == 3) {
        updateRefundRequestPendingStatus(refundDetails?.refundBasedOrderId, false);
        get_UserData(selectedUser?.primaryEmail);
      } else if (subtinentId == 989 || subtinentId == 760) {
        updateRefundRequestPendingStatus(refundDetails?.refundBasedOrderId, false);
        // For Federal Way Plaza, refresh using the specific API
        setTimeout(() => {
          loadFederalWayOrderRecords(selectedUser);
        }, 500);
      }
  }

  const TransferSubmit = async () =>{
    // console.log("TransferSubmit",transferGeneral,transferIolta,'orderDetails',orderDetails,clientAuthInsCurrent,selectedUser)

    let jsonObj = {
      "orderId": clientAuthInsCurrent?.orderId,
      "fromAccountTypeId": 1,
      "toAccountTypeId": 2,
      "transferAmount": transferIolta,
      "userId": selectedUser?.userId,
      "notes": notes
    }
    let jsonObj2 = {
      "orderId": clientAuthInsCurrent?.orderId,
      "fromAccountTypeId": 2,
      "toAccountTypeId": 1,
      "transferAmount": transferGeneral,
      "userId": selectedUser?.userId,
      "notes": notes
    }
    if(parseFloat(String(transferIolta)?.replace(/,/g, "")) > 0){
    await transferapifunction(jsonObj)
    }
    if(parseFloat(String(transferGeneral)?.replace(/,/g, "")) > 0){
    await transferapifunction(jsonObj2)
    }
    if(parseFloat(String(transferIolta)?.replace(/,/g, "")) > 0 || parseFloat(String(transferGeneral)?.replace(/,/g, "")) > 0){
    setToast({message:'Amount transferred successfully.',type:'success'})
    setIstransfer(false)
    setOpenmodal(false)
    get_UserData(selectedUser?.primaryEmail)
    }
    setTransferError(false)
  }

  const transferapifunction = async (jsonObj) => {
    setuseLoader(true)
    const transferResponse = await Services?.updateTransferService(jsonObj)
    setuseLoader(false)
    if(transferResponse != 'err'){
      console.log(transferResponse,"transferResponse")
    }
  }

  const submitWithdraw = async () => {

    let jsonObj = {
      "orderId": clientAuthInsCurrent?.orderId,
      "accountTypeId": 2,
      "withdrawAmount": withdrawAmount,
      "userId": selectedUser?.userId,
      "notes": notes,
      "remarks": withdrawRemark
    }
    setuseLoader(true)
    const withdrawResponse = await Services?.updateWithdrawnService(jsonObj)
    setuseLoader(false)
    if(withdrawResponse != 'err'){
      // console.log(withdrawResponse,"withdrawResponse")
      setToast({message:'Withdrawal has been completed successfully.',type:'success'})
      setOpenmodal(false)
      setIsWithdraw(false)
      get_UserData(selectedUser?.primaryEmail)
    }
    
  }
    
  function CloseModalFunc(){
    setOpenmodal(false)
    setTransactionStatusState("")
  }

  function openInstpaidModal(){
      setInsFullModalState(true)
  }
  
  const handleClose = () => {
    setInsFullModalState(false)
  };

  const handleCancelClick = (service, type) => {
    if (scrollRef.current) {
      scrollTopRef.current = scrollRef.current.scrollTop;
    }
    onClickCancelCompleteService(service, type);
  };

  async function onClickCancelCompleteService(serviceData,type){

      const userId = sessionStorage.getItem("loggedUserId");
      const jsonBody={
        "userAuthSubId": serviceData?.userAuthSubId,
        "authSubscriptionId": serviceData?.authSubscriptionId, 
        "isCancelSubscription": true,
        "isMatterCancel": (type=="Service")?true:false,
        "cancellationRemarks": "",
        "cancelledBy": userId
      }
      setuseLoader(true)
      let resp = await Services.postApiCallNew('POST', AoUrl.CancelUserAuthSub, jsonBody);
       if(resp?.isError!= "true"){
         const mapselectedUserData=selectedUser?.clientAuthSubsVMs?.map((data)=>{
          if(serviceData?.userAuthSubId==data?.userAuthSubId){
            return({...data,
                    isMatterCancel:((type=="Service")?true:data?.isMatterCancel),
                    isCancelSubscription:true,
                  })
          }
          return data
         })
         setSelecteduser(prev=>({...prev,clientAuthSubsVMs:mapselectedUserData || []}))
         setToast({message:'Your cancellation has been completed.',type:'success'})
         setuseLoader(false)
       }
       else{
        setToast({message:'Error occured while cancellation .',type:'error'})
        setuseLoader(false)
       }
      


  }

  const PaymentModal=()=>{
    return(<>
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/20" style={{zIndex:1}}>

    <div className="bg-white rounded-xl shadow-2xl w-[700px] h-[80vh] flex flex-col relative">

      <div className="flex justify-between rounded-xl items-center p-6 sticky top-0 bg-white z-10">
        <h2 className="text-xl font-semibold">Services/ Upcoming payments</h2>
      </div>

      <div   
        ref={scrollRef}
        className="p-6 overflow-y-auto flex-1 space-y-5"
      >
        {selectedUser?.clientAuthSubsVMs?.map((service) => {
          // console.log("rbgtfd",service)
          
          // Safety check: if clientAuthInsVMs is undefined or empty, skip this service
          if (!service?.clientAuthInsVMs || service.clientAuthInsVMs.length === 0) {
            return null;
          }
          
          let totalPaid = (service?.clientAuthInsVMs || [])?.filter(r=>r.isRefund != true)?.reduce((a, c) => { return a + c.payAmount }, 0)
          const InstOrFullPaid=(formatToUS(service?.totalAmount?.toFixed(2)) || 0)==(formatToUS(totalPaid?.toFixed(2)) || 0)
          return(<div key={service?.userAuthSubId}  className="bg-gray-100 shadow-md rounded-lg p-5">
             <div className="flex justify-between items-center">
              <div className="flex items-center gap-3">
                <h3 className="font-semibold">{service?.subscriptionName}</h3>
                <span className="bg-red-100 text-red-700 text-xs px-2 py-1 rounded">{(InstOrFullPaid)?"Full payment":"Installment"}</span>
              </div>
              <div className="text-right">
                <p className="text-sm text-gray-500">Total Amount</p>
                <p className="text-red-700 font-bold">${formatToUS(service?.totalAmount?.toFixed(2)) || 0}</p>
              </div>
            </div>

            <p className="text-sm text-gray-500 mt-2">
              Matter no : <span className="text-blue-500 ml-1">{service?.serviceMatNo || "-"}</span> • Started: {formatDateByZone(service?.authSubsStartDate)}
            </p>
             <div><p className="text-sm text-gray-500">Total Paid: <span className="text-green-700 font-semibold">${formatToUS(totalPaid?.toFixed(2)) || 0}</span></p></div>
            <div className="flex gap-4 mt-5 matterBTN">
              <button className="bg-red-800 hover:bg-red-900 text-white px-4 py-2 rounded " 
               disabled={service?.isMatterCancel}
               onClick={()=> handleCancelClick(service,"Service")}>Cancel Complete Service</button>
              {(service?.authSubscriptionId!=null && service?.authSubscriptionId!="") && <button  disabled={service?.isCancelSubscription}  className=" bg-black hover:bg-gray-900 text-white px-4 py-2 rounded" onClick={()=>handleCancelClick(service,"Scheduled")}>Cancel Scheduled Payments</button>}
            </div> 
          </div>
        )}
        )}
      </div>

      {/* Sticky Footer */}
      <div className="p-4 rounded-xl  bg-gray-50 flex justify-end sticky bottom-0 z-10">
        <button
          onClick={handleClose}
          className="bg-red-800 text-white px-4 py-2 rounded"
        >
          Close
        </button>
      </div>

    </div>
  </div>
    </>  
     )}

     const [selected, setSelected] = useState("");
     const [open, setOpen] = useState(false);
     const options = ["All","A51-356919", "B1356919", "-"];
  
    async function onClickCancelpayment(mainData,firstSchData,type,indexValue){

    const {userAuthSubId,authSubscriptionId}=mainData
    const loginUserId = sessionStorage.getItem("loggedUserId")
    const getNextStartDateData=mainData?.clientAuthSchVMs.find((values,index)=>{
        return indexValue==index
    })
    // console.log("fds",getNextStartDateData?.installmentDate)
    let inputData={
      userAuthSubsId:userAuthSubId,
      authSubscriptionId,
      subtenantId:subtinentId,
      isSubsCancel: (type=="Scheduled Cancel")?true:false, // for cancel sch payments "True" // cancel ke lie "False"
      isSubsPaySkip: (type=="Scheduled Cancel")?false:true, // for cancel sch payments "false" // cancel ke lie "true"
      isSubsPayShift: false,
      countofPay:indexValue,
      nextStartDate: getNextStartDateData?.installmentDate,// if first cancel then send 2nd upcoming payment date / if second cancel then 3rd upcoming payment date
      isActive: true,
      createdBy:loginUserId
      
    }
    
    // console.log("99inputDate",inputData)
    try{
    setuseLoader(true)
    const _resultOf = await Services.CreateModifySubsRequest(inputData);
        let resData = _resultOf?.data;
        // console.log("rtefv",resData)
        setToast({ message: `Cancellation request created successfully.`, type: "success" });
        setTriggerUpdateApi(true)
        setuseLoader(false)
        
    }catch(err){
      setuseLoader(false)
    } 
   
  
  }

  function funCheckNoScheduledFound(selectedUser){
      // console.log("3eselectedUser",selectedUser.clientAuthSubsVMs.every((data)=>data?.clientAuthSchVMs.length==0))
      return (selectedUser?.clientAuthSubsVMs?.every((data)=>data?.clientAuthSchVMs?.length==0) || 0)
  }

  
    
    return <>
    {insFullModalState && <PaymentModal/>}
    <div className="bg-[#ffffff] px-4 py-2">
    {/* <h1 className="bg-white py-2 font-semibold text-lg">Refund Section</h1> */}
    {<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <SearchBar  setTriggerUpdateApi={setTriggerUpdateApi} triggerUpdateApi={triggerUpdateApi} setuseLoader={setuseLoader} showDropdown={showDropdown} setMatterNumber={setMatterNumber} matterNumber={matterNumber} results={results} setSearchData={setSearchData} runApis={runApis} pageName="refundSearchBar" subtinentId={subtinentId} reference={(subtinentId == 989 || subtinentId == 760) ? 'FederalWay' : undefined}/>
    </div>}
     {(showUserForm == true ) && (subtinentId == 989 || subtinentId == 760) ? (
       <FederalWayRefundForm 
         selectedUser={selectedUser} 
         setSelecteduser={setSelecteduser} 
         updateUser={updateUser} 
         setToast={setToast} 
         subtenantId={subtinentId} 
         setuseLoader={setuseLoader}
         setSelectedUserData={setSelectedUserData}
         setshowUserForm={setshowUserForm}
         loadFederalWayOrderRecords={loadFederalWayOrderRecords}
       />
     ) : (showUserForm == true ) && <AddNewUser selectedUser={selectedUser} setSelecteduser={setSelecteduser} updateUser={updateUser} referencePage={subtinentId == 3 ? "agingoption" : "lpl"} setToast={setToast} subtenantId={subtinentId} timeMatter={timeMatter} setMatterNumber={setMatterNumber} setTimematter={setTimematter} noUpdate={true} />}
     {selectedUser?.clientAuthSubsVMs?.length > 0 ? <><hr className="mt-4" /><h2 className="font-semibold mt-2 dFlexProp" ref={servicetyperef}>{(showScheduledPyaments==true)?"Upcoming scheduled payments:":"Services availed by client till date: "}
      {(subtinentId != 3 && subtinentId != 989 && subtinentId != 760) && <button 
       onClick={()=>setShowScheduledPayments(!showScheduledPyaments)}
       className="px-2 py-2 bg-[#720c20] text-white rounded-md hover:bg-[#720c20]"
       >
        {(showScheduledPyaments==false)?"Show Upcoming payments":"Show Paid Payments"}
        </button>}
      
      
      </h2></>:<p className="mt-3 ms-1">No records</p>}
     {/* {console.log(selectedUser?.clientAuthSubsVMs,"selectedUserclientAuthSubsVMs")} */}
     {selectedUser?.clientAuthSubsVMs?.length > 0 ? 
     <table className="w-full table border rounded-[5px] mt-3 mb-3">
                 {(showScheduledPyaments==false)?<>  <thead>
                  <tr style={headerStyle}>
                    {serviceHead.map((e) => (<th style={headerStyle} className="!items-center">{e}</th>))}
                    {/* {serviceHead.map((e) => (<th style={headerStyleTop} className={`${(e=="Due Date")?"dflexCol":""}`}><span>{e}</span> {(e=="Due Date")?<span className={`dateFormat`}>[MM-DD-YYYY]</span>:""}</th>))} */}
                  </tr>
                </thead>
                <tbody>
                  {/* {console.log("serviceserviceserviceservice2",selectedUser?.clientAuthSubsVMs,'issplitPayment',issplitPayment)} */}
                  {(selectedUser?.clientAuthSubsVMs && Array.isArray(selectedUser.clientAuthSubsVMs) ? [...selectedUser.clientAuthSubsVMs] : [])?.sort((a, b) => new Date(a?.authSubsStartDate) - new Date(b?.authSubsStartDate))?.map((service) => {
                 //    console.log(service,"serviceserviceserviceservice",selectedUser?.clientAuthSubsVMs,'issplitPayment',issplitPayment)
                 
                    // Safety check: if clientAuthInsVMs is undefined or empty, skip this service
                    if (!service?.clientAuthInsVMs || service.clientAuthInsVMs.length === 0) {
                      return null;
                    }
                    
                    let totalPaid = (service?.clientAuthInsVMs || [])?.filter(r => {
                      // For Federal Way Plaza, include all non-refunded records (including reversed)
                      if (subtinentId == 989 || subtinentId == 760) {
                        return r.isRefund != true;
                      }
                      // For other subtenants, only non-refunded records
                      return r.isRefund != true;
                    })?.reduce((a, c) => { return a + c.payAmount }, 0) || 0
  
                   //  let pendingAmount = service?.totalAmount?.toFixed(2) - (service?.totalDiscount || 0)?.toFixed(2) - totalPaid?.toFixed(2);
                  //  console.log(service?.clientAuthInsVMs,"serviceclientAuthInsVMs",selectedUser?.clientAuthSubsVMs)
                   const rows = (service?.clientAuthInsVMs || [])?.filter(
                   e => {
                     // Only show non-refund records as actionable rows for all subtenants
                     // Refund entries are used for calculating refunedAmount, not as display rows
                     return e?.isRefund !== true;
                   }
                   ) || [];
                     return (service?.clientAuthInsVMs || [])?.length > 1
                       ? rows.map((e, index) => {
                       const isFirstRow = index === 0;
                       const rowSpan = rows.length;
                       const refundedArray = (service?.clientAuthInsVMs || [])?.filter((r)=> r.refundBasedOrderId == e?.orderId)
                       const refunedAmount = refundedArray?.reduce((a, c) => a + (Number(c.payAmount) || 0), 0) ?? 0;
                       // console.log(refundedArray,'refundedArray',refunedAmount,"rowsrows",service?.clientAuthInsVMs,e)
                       let newPayamount = refunedAmount != undefined ? (e.payAmount) - (refunedAmount) : e.payAmount
                       let updatedAccountType = [];
                       if(refundedArray?.length > 0 && e?.accountType != null){
                       updatedAccountType = JSON.stringify(calculateAccountTypediffrence(e?.accountType,refundedArray))
                       }
                       // console.log(newPayamount,"newPayamount",refunedAmount)
                       // console.log(e,'fhjhfjfjdrefundedArray',refundedArray,"updatedAccountType",updatedAccountType)
                       let currentEle = {...e,payAmount:(refundedArray?.length > 0 && refunedAmount != e?.payAmount) ? newPayamount : e?.payAmount, accountType: refundedArray?.length > 0 && refunedAmount != e?.payAmount ? updatedAccountType : e?.AccountType }
                       // console.log(newPayamount,"newPayamount2",refunedAmount)
                       // console.log(e,"sgshghshsghs",(refundedArray?.length > 0 && refunedAmount != e?.payAmount),refunedAmount )
                       // console.log(e,"eisRefundRequestInPending")
                       return (
                         <tr key={index}>
                           {/* MERGED SERVICE COLUMNS */}
                           {isFirstRow && (
                             <>
                               {subtinentId != 3 && (subtinentId != 989 && subtinentId != 760) && <td style={cellStyle} rowSpan={rowSpan}>
                                 {service?.serviceMatNo || '-'}
                               </td>}
                               
                               {(subtinentId == 989 || subtinentId == 760) && (
                                 <>
                                   <td style={cellStyle} rowSpan={rowSpan}>
                                     {selectedUser?.tenantName || selectedUser?.fullName || '-'}
                                   </td>
                                   <td style={cellStyle} rowSpan={rowSpan}>
                                     {selectedUser?.unitNumber || selectedUser?.matNo || '-'}
                                   </td>
                                 </>
                               )}

                               <td style={cellStyle} rowSpan={rowSpan}>
                                 {service?.subscriptionName}
                                 {service?.totalOccurrence === 9999 && ' -(Renew Added)'}
                               </td>

                               {/* <td style={cellStyle} rowSpan={rowSpan}>
                                 {formatDateByZone(e?.usaPayAmountDate)}
                               </td> */}

                               <td style={cellStyle} rowSpan={rowSpan}>
                                 ${formatToUS(service?.totalAmount?.toFixed(2)) || 0}
                               </td>

                               <td style={cellStyle} rowSpan={rowSpan}>
                                 {e?.paymentType || '-'}
                               </td>
                             </>
                           )}

                            {/* <td style={cellStyle}>
                                 {getTodayDateUSFormat(service?.authSubsStartDate)}
                           </td> */}

                            <td style={cellStyle} >
                                 {formatDateByZone(e?.usaPayAmountDate)}
                               </td>
                           
                           <td style={cellStyle}>
                             ${formatToUS(e?.payAmount?.toFixed(2))} 
                           </td>
                           <td style={cellStyle}>${refunedAmount?.toFixed(2) || 0}</td>
                           <td style={cellStyle}>{
                             e?.isReverse === true ? 'Reversed' :
                             e?.isRefundRequestInPending == true ? 'Pending' : 
                             (service?.clientAuthInsVMs?.some((r)=> r.refundBasedOrderId == e?.orderId) && refunedAmount == e?.payAmount) ? 'Completed' :
                             (e?.paymentTypeId === 4 || e?.paymentTypeId === 1 || e?.paymentTypeId === 6) ? 'Paid' :
                             'Active'
                           }</td>
                           <td style={cellStyle}>
                             <button
                               className={`px-2 py-1 bg-green-500 text-white rounded-md hover:bg-green-600 ms-2 my-2 ${
                                 totalPaid === 0 || (service?.clientAuthInsVMs?.some((r)=> r.refundBasedOrderId == e?.orderId) && refunedAmount == e?.payAmount) || e?.isRefundRequestInPending == true || isActionDisabledDueToReverse(e)
                                   ? '!bg-green-300 hover:bg-green-300 cursor-not-allowed'
                                   : ''
                               }`}
                               disabled={(service?.clientAuthInsVMs?.some((r)=> r.refundBasedOrderId == e?.orderId) && refunedAmount == e?.payAmount) || e?.isRefundRequestInPending == true || isActionDisabledDueToReverse(e)}
                               onClick={() => refundFunction(service, (refundedArray?.length > 0 && refunedAmount != e?.payAmount) ? currentEle : e)}
                             >
                               Refund
                             </button>
                             {e?.isRefundRequestInPending == true && <button className="px-2 py-1 bg-red-500 hover:bg-red-600 text-white rounded-md ms-2" onClick={()=>onCancelRefund(e?.orderId)}>Cancel</button>}
                             <hr/>
                             {(subtinentId != 3 && subtinentId != 989 && subtinentId != 760) && <button className={`px-2 mx-2 py-1 bg-green-500 text-white rounded-md hover:bg-green-600 my-2 ${totalPaid === 0 || (service?.clientAuthInsVMs?.some((r)=> r.refundBasedOrderId == e?.orderId) && refunedAmount == e?.payAmount) || e?.isRefundRequestInPending == true || isActionDisabledDueToReverse(e) ? '!bg-green-300 hover:bg-green-300 cursor-not-allowed' : ''}`} disabled={(service?.clientAuthInsVMs?.some((r)=> r.refundBasedOrderId == e?.orderId) && refunedAmount == e?.payAmount) || e?.isRefundRequestInPending == true || isActionDisabledDueToReverse(e)} onClick={()=>TransferFunction(service, (refundedArray?.length > 0 && refunedAmount != e?.payAmount) ? currentEle : e)}>Transfer</button>}
                             {/* <hr/> */}
                             {(subtinentId != 3 && subtinentId != 989 && subtinentId != 760) && <button className={`px-2 mx-2 py-1 bg-green-500 text-white rounded-md hover:bg-green-600 my-2 ${totalPaid == 0 || (service?.clientAuthInsVMs?.some((r)=> r.refundBasedOrderId == e?.orderId) && refunedAmount == e?.payAmount) || e?.isRefundRequestInPending == true || isActionDisabledDueToReverse(e) ? '!bg-green-300 hover:bg-green-300 cursor-not-allowed' : ''}`} disabled={(service?.clientAuthInsVMs?.some((r)=> r.refundBasedOrderId == e?.orderId) && refunedAmount == e?.payAmount) || e?.isRefundRequestInPending == true || totalPaid == 0 || isActionDisabledDueToReverse(e) ? true : false} onClick={()=>withdrawFunction(service,(refundedArray?.length > 0 && refunedAmount != e?.payAmount) ? currentEle : e)}>Withdraw</button>}
                             
                             {/* Reverse Button */}
                             {shouldShowReverseButton(e) && (
                               <>
                                 <hr/>
                                 <button 
                                   className={`px-2 mx-2 py-1 text-white rounded-md my-2 ${
                                     isReverseDisabled(e, service) 
                                       ? 'bg-red-300 hover:bg-red-300 cursor-not-allowed' 
                                       : 'bg-red-500 hover:bg-red-600'
                                   }`}
                                   disabled={isReverseDisabled(e, service)}
                                   onClick={() => reverseFunction(e)}
                                 >
                                   Reverse
                                 </button>
                               </>
                             )}

                           </td>
                         </tr>
                       )})
                      : <tr className="w-100" style={cellStyle}> 
                       {subtinentId != 3 && (subtinentId != 989 && subtinentId != 760) && <td style={cellStyle}>{service?.serviceMatNo || '-'}</td>}
                       
                       {(subtinentId == 989 || subtinentId == 760) && (
                         <>
                           <td style={cellStyle}>{selectedUser?.tenantName || selectedUser?.fullName || '-'}</td>
                           <td style={cellStyle}>{selectedUser?.unitNumber || selectedUser?.matNo || '-'}</td>
                         </>
                       )}
                       
                      <td style={cellStyle}>{service?.subscriptionName} {service?.totalOccurrence == 9999 && '-(Renew Added)'}</td>
                      <td style={cellStyle}>${formatToUS(service?.totalAmount?.toFixed(2)) || 0}</td>
                      <td style={cellStyle}>{(service?.clientAuthInsVMs || [])[0]?.paymentType || '-'}</td>
                      <td style={cellStyle}>{formatDateByZone((service?.clientAuthInsVMs || [])[0]?.usaPayAmountDate)}</td>
                       <td style={cellStyle}>${formatToUS(totalPaid?.toFixed(2)) || 0}</td>
                       <td style={cellStyle}>
                         ${(() => {
                           // Calculate refunded amount for single record view
                           const refundedArray = (service?.clientAuthInsVMs || [])?.filter((r) => r.refundBasedOrderId == (service?.clientAuthInsVMs || [])[0]?.orderId);
                           const refunedAmount = refundedArray?.reduce((a, c) => a + (Number(c.payAmount) || 0), 0) ?? 0;
                           return refunedAmount?.toFixed(2) || 0;
                         })()}
                       </td>
                       <td style={cellStyle}>{
                         (service?.clientAuthInsVMs || [])[0]?.isReverse === true ? 'Reversed' :
                         (service?.clientAuthInsVMs || [])[0]?.isRefundRequestInPending == true ? 'Pending' : 
                         (totalPaid > 0 && ((service?.clientAuthInsVMs || [])[0]?.paymentTypeId === 4 || (service?.clientAuthInsVMs || [])[0]?.paymentTypeId === 1 || (service?.clientAuthInsVMs || [])[0]?.paymentTypeId === 6)) ? 'Paid' :
                         (totalPaid == 0) ? 'Completed' : 
                         'Active'
                       }</td>
                       <td style={cellStyle} className="">
                         <button className={`px-2 py-1 bg-green-500 text-white rounded-md hover:bg-green-600 ms-2 my-2 ${totalPaid == 0 || (service?.clientAuthInsVMs || [])[0]?.isRefundRequestInPending == true || isActionDisabledDueToReverse((service?.clientAuthInsVMs || [])[0]) ? '!bg-green-300 hover:bg-green-300 cursor-not-allowed' : ''}`} disabled={totalPaid == 0 || (service?.clientAuthInsVMs || [])[0]?.isRefundRequestInPending == true || isActionDisabledDueToReverse((service?.clientAuthInsVMs || [])[0]) ? true : false} onClick={()=>refundFunction(service)}>Refund</button>
                         {(service?.clientAuthInsVMs || [])[0]?.isRefundRequestInPending == true && <button className="px-2 py-1 bg-red-500 hover:bg-red-600 text-white rounded-md ms-2" onClick={()=>onCancelRefund((service?.clientAuthInsVMs || [])[0]?.orderId)}>Cancel</button>}
                         {/* {console.log((service?.clientAuthInsVMs || [])[0],"hdjshdsjjs")} */}
                         <hr/>
                         {(subtinentId != 3 && subtinentId != 989 && subtinentId != 760) && <button className={`px-2 py-1 bg-green-500 text-white rounded-md hover:bg-green-600 my-2 ${totalPaid == 0 || (service?.clientAuthInsVMs || [])[0]?.isRefundRequestInPending == true || isActionDisabledDueToReverse((service?.clientAuthInsVMs || [])[0]) ? '!bg-green-300 hover:bg-green-300 cursor-not-allowed' : ''}`} disabled={totalPaid == 0 || (service?.clientAuthInsVMs || [])[0]?.isRefundRequestInPending == true || isActionDisabledDueToReverse((service?.clientAuthInsVMs || [])[0]) ? true : false} onClick={()=>TransferFunction(service)}>Transfer</button>}
                         {(subtinentId != 3 && subtinentId != 989 && subtinentId != 760) && <button className={`px-2 py-1 bg-green-500 text-white rounded-md hover:bg-green-600 my-2 ms-2 ${totalPaid == 0 || (service?.clientAuthInsVMs || [])[0]?.isRefundRequestInPending == true || isActionDisabledDueToReverse((service?.clientAuthInsVMs || [])[0]) ? '!bg-green-300 hover:bg-green-300 cursor-not-allowed' : ''}`} disabled={totalPaid == 0 || (service?.clientAuthInsVMs || [])[0]?.isRefundRequestInPending == true || isActionDisabledDueToReverse((service?.clientAuthInsVMs || [])[0]) ? true : false} onClick={()=>withdrawFunction(service)}>Withdraw</button>}
                         
                         {/* Reverse Button */}
                         {shouldShowReverseButton((service?.clientAuthInsVMs || [])[0]) && (
                           <>
                             <hr/>
                             <button 
                               className={`px-2 py-1 text-white rounded-md my-2 ms-2 ${
                                 isReverseDisabled((service?.clientAuthInsVMs || [])[0], service) 
                                   ? 'bg-red-300 hover:bg-red-300 cursor-not-allowed' 
                                   : 'bg-red-500 hover:bg-red-600'
                               }`}
                               disabled={isReverseDisabled((service?.clientAuthInsVMs || [])[0], service)}
                               onClick={() => reverseFunction((service?.clientAuthInsVMs || [])[0])}
                             >
                               Reverse
                             </button>
                           </>
                         )}
                         </td>
                      </tr>}
                     )}
                </tbody></>:<>  <thead>
                  <tr style={headerStyle}>
                  {subtinentId != 3 && <th style={headerStyle} className="cursor_pointer relative">

                    <div
                      className="flex items-center justify-between"
                      onClick={() => setMatterFilterOpen(!matterFilterOpen)}
                    >
                      <span>Matter no</span>
                      <button className="ml-2 text-sm">▼</button>
                    </div>
                      {matterFilterOpen && (
                        <div className="absolute left-0 top-full z-10 mt-1 w-full min-w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                          <div
                            className="cursor-pointer py-2 pl-3 pr-3 hover:bg-gray-100"
                            onClick={() => {
                              setSelectedMatterFilter('');
                              setMatterFilterOpen(false);
                            }}
                          >
                            All
                          </div>
                          {[...new Set(
                            selectedUser?.clientAuthSubsVMs
                              ?.map(item => {
                                if (
                                  item?.authSubscriptionId == null ||
                                  item?.isCancelSubscription === true
                                ) {
                                  return null;
                                }
                                return item?.serviceMatNo;
                              })
                              .filter(Boolean)
                          )].map((matterNo) => (
                            <div
                              key={matterNo}
                              className={`cursor-pointer py-2 pl-3 pr-3 hover:bg-gray-100 ${
                                selectedMatterFilter === matterNo
                                  ? "bg-indigo-100 text-indigo-900"
                                  : "text-gray-900"
                              }`}
                              onClick={() => {
                                setSelectedMatterFilter(matterNo);
                                setMatterFilterOpen(false);
                              }}
                            >
                              {matterNo}
                            </div>
                          ))}

                        </div>
                      )}
                  </th>}
                    <th style={headerStyle} className="!items-center">{"Service Name"}</th>
                     <th style={headerStyle} className="!items-center">{"Cancel Request"}</th>
                    <th style={headerStyle} className="!items-center">{"Upcoming Payment Date"}</th>
                    <th style={headerStyle} className="!items-center">{"Payment mode"}</th>
                    <th style={headerStyle} className="!items-center">{"To pay"}</th>
                   
                    <th style={headerStyle} className="!items-center">{"Action"}</th>
                  </tr>
                </thead>
                <tbody>

      
                { (selectedUser?.clientAuthSubsVMs)
                   ?.filter(val1 => !selectedMatterFilter || val1?.serviceMatNo === selectedMatterFilter)
                   ?.map((val1)=>{
                            // console.log("88evfd",val1)
                            const rowSpanConst=val1.clientAuthSchVMs?.length
                            const lengthCheck=val1?.clientAuthSchVMs?.length
                            // console.log("brgvf",lengthCheck)
                            if(lengthCheck==0)return
                            const firstSchData=val1?.clientAuthSchVMs?.[0]
                            const disableCancelBtn=(val1?.modSubReqId!=null && val1?.modSubReqId!="" )
                            return(<>
                                    <tr>
                                       {subtinentId != 3 && <td style={cellStyle} rowSpan={rowSpanConst}>
                                          {val1?.serviceMatNo || "-"}
                                          <p><button disabled={disableCancelBtn} className={`px-2 py-1 bg-red-500 text-white rounded-md styleDisabled`} onClick={()=>{onClickCancelpayment(val1,firstSchData,"Scheduled Cancel")}}>Cancel Scheduled payments</button></p>
                                      </td>}
                                      <td style={cellStyle} rowSpan={rowSpanConst}>{val1?.subscriptionName}</td>  
                                      <td style={cellStyle} rowSpan={rowSpanConst}>{(disableCancelBtn==true)?"Pending":"-"}</td>
                                      <td style={cellStyle}>{formatDateByZone(firstSchData?.installmentDate)}</td>
                                      <td style={cellStyle}>{(firstSchData?.paymentType)}</td>
                                      <td style={cellStyle}>${formatToUS(firstSchData?.installmentAmt?.toFixed(2)) || 0}</td>
                                      <td style={cellStyle} className="">
                                        <div className="my-2 " style={{height:"35px"}}>
                                          {lengthCheck>1 && <button disabled={disableCancelBtn} className={`px-2 py-1 bg-red-500 text-white rounded-md styleDisabled`} onClick={()=>{onClickCancelpayment(val1,firstSchData,"Cancel",1)}}>Cancel</button>}
                                        </div>
                                      </td>
                                    </tr>
                                    {(val1?.clientAuthSchVMs?.length>0) && val1?.clientAuthSchVMs?.map((data,index,arr)=>{
                                      if(index==0)return
                                      const showCancelButton=(lengthCheck<2 || (lengthCheck>2 && index<2))
                                      return(
                                        <tr>
                                          <td style={cellStyle}>{formatDateByZone(data?.installmentDate)}</td>
                                          <td style={cellStyle}>{(val1?.clientAuthSchVMs?.[0]?.paymentType)}</td>
                                          <td style={cellStyle}>${formatToUS(val1?.clientAuthSchVMs?.[0]?.installmentAmt?.toFixed(2)) || 0}</td>
                                          <td style={cellStyle} className="">
                                          <div className="my-2 " style={{height:"35px"}}>
                                             {showCancelButton==true && <button disabled={disableCancelBtn} className={`px-2 py-1 bg-red-500 text-white rounded-md styleDisabled`} onClick={()=>{onClickCancelpayment(val1,data,"Cancel",index+1)}}>Cancel</button>}
                                             </div>
                                          </td>
                                        </tr>
                                      )
                                    })}
                            </>)})
                    }
                            {funCheckNoScheduledFound(selectedUser)==true? <tr>
                              <td> </td><td> </td><td></td><td><p className="mt-2 mb-2">"No record found"</p></td>
                              </tr>:<tr></tr>}
                </tbody>
                
                </>
                 }
                 </table> 
              : ''}
    </div>
    {openModal && (
        <div className="fixed inset-0 z-20 flex items-center justify-center bg-black/50">
          <div className="relative bg-white rounded-lg shadow-lg w-full max-w-lg p-3 max-h-[96vh] overflow-hidden flex flex-col">

            {/* Close Button */}
            <button
              onClick={CloseModalFunc}
              aria-label="Close modal"
              className="absolute top-4 right-4 p-2 rounded-full
                         text-gray-400 hover:bg-gray-100 hover:text-gray-700
                         focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            {/* Header */}
            <h2 className="text-lg font-semibold text-gray-800 p-2">
              {isTransfer == true ? 'Transfer' : isWithdraw == true ? 'Withdraw' : 'Refund'} Details
            </h2>

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-2">
              {/* {console.log(orderDetails,"orderDetailsselectedUser",selectedUser)} */}
                {orderDetails != null && <div className="bg-[#ffffff]">
                <div className="flex justify-between mt-1">
                  <div>
                    <span className="font-semibold">Client:</span> {selectedUser?.fullName}
                  </div>
                  <div>
                    <span className="font-semibold">Requested By:</span> {loggedInUserDetails?.memberName}
                  </div>
                </div>
                <div>
                  <span className="font-semibold mt-1">Mat no:</span> {orderDetails?.serviceMatNo || '-'}
                </div>
              <h1 className="mb-2 font-semibold">Service Type: </h1>
              <SearchableSelect
              value={Number(serviceType)}
              options={service}
              optionLabel={(o) => o.subscriptionName}
              optionValue={(o) => o.subscriptionId}
              onChange={(value) => setServiceType(value)}
              disabled={true}
              placeholder={`Select Service Type`}
              />
              {serviceType == 9 && <>
                <div className="flex w-100 justify-between align-center mt-1">
                  <h3 className="font-semibold mb-2">Other Description</h3>
                </div>
                <input
                  type="text"
                  className="pl-3 pr-4 py-2 w-full border border-gray-300 rounded-md bg-gray-200"
                  placeholder='Enter Description'
                  value={orderDetails?.subscriptionName || ''}
                  disabled
                />
              </>}
    <div className="mt-2">
        {isTransfer == true ? <> 
        <p className="font-semibold">Total Paid</p>
        <div className="relative mt-2 w-100">
          <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
          <span className="text-gray-500">$</span>
        </div>
        <input
          type="input"
          label="Amount"
          placeholder="Enter amount"
          value={formatToUS(totalAmount?.toString()) || '0.00'}
          // onChange={(e) => setRefundAmount(e.target.value)}
          className={`border py-2 rounded w-100 pl-6 ${'bg-gray-200 cursor-not-allowed'}`}
          // disabled={(issplitPaymentSession) ? true : false}
          disabled={true}
        />
        </div>
        <div className="bg-white mt-4">
            {/* <h2 className="block font-medium text-gray-700 mb-1"></h2> */}
            <div className="w-100 gap-6">
              {parseFloat(String(paymentAmount?.find((f)=> f.AccountTypeId == 1)?.Amount || 0)?.replace(/,/g, ""))  > 0 && <div>
              {chackboxButtonAccount('General Account', 1, paymentAmount, setPaymentamount)}
              <p className="font-semibold">Transfer to</p>
              <div className="flex items-center gap-2">
              <p>IOLTA Account</p>
              <div className="relative mt-1 w-100">
              <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
              <span className="text-gray-500">$</span>
              </div>
              <input
              type="input"
              label="Amount"
              placeholder="Enter amount"
              value={formatToUS(transferIolta?.toString()) || ''}
              onChange={(e) => setTransferIolta(e.target.value)}
              className={`border py-2 rounded w-[70%] pl-6`}
              // disabled={(issplitPaymentSession) ? true : false}
              // disabled={true}
              />
              </div>
              </div>
              {/* {console.log(parseFloat(String(paymentAmount?.find((f)=> f.AccountTypeId == 1)?.Amount || 0)?.replace(/,/g, "")) ,transferIolta,"kdlskdlskdlskdsl")} */}
              {parseFloat(String(transferIolta)?.replace(/,/g, "")) > parseFloat(String(paymentAmount?.find((f)=> f.AccountTypeId == 1)?.Amount || 0)?.replace(/,/g, "")) && <p className="mt-1 text-[red]">Transfer amount exceeds available balance.</p>}
              </div>}
              <hr className="my-2" />
              {parseFloat(String(paymentAmount?.find((f)=> f.AccountTypeId == 2)?.Amount || 0)?.replace(/,/g, "")) > 0 && <>
              {chackboxButtonAccount('IOLTA Account', 2, paymentAmount, setPaymentamount)}
              <p className="font-semibold">Transfer to</p>
              <div className="flex items-center gap-2">
              <p>General Account</p>
              <div className="relative mt-1 w-100">
              <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
              <span className="text-gray-500">$</span>
              </div>
              <input
              type="input"
              label="Amount"
              placeholder="Enter amount"
              value={formatToUS(transferGeneral?.toString()) || ''}
              onChange={(e) => setTransferGeneral(e.target.value)}
              className={`border py-2 rounded w-[70%] pl-6`}
              // disabled={(issplitPaymentSession) ? true : false}
              // disabled={true}
              />
              </div>
              </div>
              {parseFloat(String(transferGeneral)?.replace(/,/g, "")) > parseFloat(String(paymentAmount?.find((f)=> f.AccountTypeId == 2)?.Amount || 0)?.replace(/,/g, "")) && <p className="mt-1 text-[red]">Transfer amount exceeds available balance.</p>}
              </>}
            </div>
          </div>
        
        </> : isWithdraw == true ? <>
        <p className="font-semibold">Total Paid</p>
        <div className="relative mt-2 w-100">
          <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
          <span className="text-gray-500">$</span>
        </div>
        <input
          type="input"
          label="Amount"
          placeholder="Enter amount"
          value={formatToUS(totalAmount?.toString()) || '0.00'}
          // onChange={(e) => setRefundAmount(e.target.value)}
          className={`border py-2 rounded w-100 pl-6 ${'bg-gray-200 cursor-not-allowed'}`}
          // disabled={(issplitPaymentSession) ? true : false}
          disabled={true}
        />
        </div>
        <div>
          <p className="font-semibold mt-1">Amount Received in Account:</p>
          <div className="flex gap-2 mt-1">
          <p>General Account: ${(paymentAmount?.find((f)=> f.AccountTypeId == 1)?.Amount) || 0}</p> |
          <p>IOLTA Account: ${(paymentAmount?.find((f)=> f.AccountTypeId == 2)?.Amount) || 0}</p>
          </div>
          </div>
          <hr className="my-2"/>
        <div className="mt-2">
          <label className="font-semibold">Enter amount to withdraw from IOLTA account</label>
           <div className="relative mt-2 w-100">
          <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
          <span className="text-gray-500">$</span>
        </div>
        <input
          type="input"
          label="Amount"
          placeholder="Enter amount"
          value={formatToUS(withdrawAmount?.toString()) || ''}
          onChange={(e) => setWithdrawamount(e.target.value)}
          className={`border py-2 rounded w-100 pl-6`}
          // disabled={(issplitPaymentSession) ? true : false}
          // disabled={true}
        />
        </div>
        {parseFloat(String(withdrawAmount)?.replace(/,/g, "")) > parseFloat(String(paymentAmount?.find((f)=> f.AccountTypeId == 2)?.Amount || 0)?.replace(/,/g, "")) && <p className="text-[red] mt-1">Amount does not exceed the received IOLTA amount.</p>}
        </div>
        <div className="bg-white p-0">
            <h1 className="font-semibold mb-2 mt-2">Remark</h1>
            <textarea className="pl-2 py-2 w-full border border-gray-300 rounded-md" placeholder='Enter remark here...' value={withdrawRemark} onChange={(e) => setWithdrawRemark(e.target.value)} />
        </div>
        </> : <>
        <><p className="mt-2 font-semibold">Do you want to issue a {isTransfer == true ? 'Transfer' : 'Refund'}?</p>
        <div className="relative flex gap-3 mt-2">
        {radioButton('Full','Yes',refundType,setRefundtype)}
        {/* Hide Partial option for Aging Options (3) and Federal Way Plaza (989, 760) when payment type is card (paymentTypeId = 1) */}
        {transactionStatusState!="capturedPendingSettlement" && 
         !((subtinentId == 3 || subtinentId == 989 || subtinentId == 760) && clientAuthInsCurrent?.paymentTypeId == 1) && 
         radioButton('Partial','No',refundType,setRefundtype)}
        </div>
        </>
        {refundType == 'Yes' ? <><p className="mt-2 font-semibold">{isTransfer == true ? 'Transfer' : 'Refund'} Amount</p>
        <div className="relative mt-2 w-100">
          <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
          <span className="text-gray-500">$</span>
        </div>
        <input
          type="input"
          label="Amount"
          placeholder="Enter amount"
          value={refundAmount || ''}
          onChange={(e) => setRefundAmount(e.target.value)}
          className={`border py-2 rounded w-100 pl-6 ${refundType == 'Yes' ? 'bg-gray-200 cursor-not-allowed' : ''}`}
          // disabled={(issplitPaymentSession) ? true : false}
          disabled={refundType == 'Yes' ? true : false}
        />
        </div>
        <div className="bg-white mt-4">
            {/* <h2 className="block font-medium text-gray-700 mb-1"></h2> */}
            <div className="w-100 gap-6">
              {(subtinentId != 3 && subtinentId != 989 && subtinentId != 760) && chackboxButtonAccount('General Account', 1, paymentAmount, setPaymentamount)}
              {(subtinentId != 3 && subtinentId != 989 && subtinentId != 760) && chackboxButtonAccount('IOLTA Account', 2, paymentAmount, setPaymentamount)}
              {(subtinentId != 3 && subtinentId != 989 && subtinentId != 760) && <p className="text-[12px] italic">(Refunds for IOLTA account are always issued via check payment method.)</p>}
            </div>
          </div>
          </>
           :<>
        <h1 className="mt-1"><span className="font-semibold">Total Paid:</span> ${formatToUS(totalAmount?.toString()) || '0.00'}</h1>
        {(subtinentId != 3 && subtinentId != 989 && subtinentId != 760) && <div>
          <p className="font-semibold mt-1">Received Amount Breakdown:</p>
          <div className="flex gap-2 mt-1">
          <p>General Account: ${(paymentAmount?.find((f)=> f.AccountTypeId == 1)?.Amount) || 0}</p> |
          <p>IOLTA Account: ${(paymentAmount?.find((f)=> f.AccountTypeId == 2)?.Amount) || 0}</p>
          </div>
        </div>}
        <h1 className="mt-2 font-semibold">Refund Amount:</h1>
        <div className="relative mt-2 w-100">
          <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
          <span className="text-gray-500">$</span>
        </div>
        <input
          type="type"
          label="Amount"
          placeholder="Enter amount"
          value={formatToUS(refundAmount?.toString()) || ''}
          onChange={(e) => {refundInput(e)}}
          className={`border py-2 rounded w-100 pl-6 ${refundType == 'Yes' ? 'bg-gray-200 cursor-not-allowed' : ''}`}
          // disabled={(issplitPaymentSession) ? true : false}
          disabled={refundType == 'Yes' ? true : false}
        />
        </div>
        
        {refundErr != '' && <p className="mt-1 text-[red]">{refundErr}</p>}
        <div className="bg-white mt-4">
            <h2 className="block font-medium text-gray-700 mb-1"></h2>
            <div className="w-100 gap-6">
              {(subtinentId != 3 && subtinentId != 989 && subtinentId != 760) && chackboxButtonAccount('General Account', 1, paymentAmountPartial, setPaymentamountPartial,parseFloat(String(paymentAmount?.find((f)=> f.AccountTypeId == 1)?.Amount || 0)?.replace(/,/g, "")) == 0 ? true : false)}
              {(subtinentId != 3 && subtinentId != 989 && subtinentId != 760) && parseFloat(String(paymentAmount?.find((f)=> f.AccountTypeId == 1)?.Amount || 0)?.replace(/,/g, "")) < parseFloat(paymentAmountPartial?.find((f)=> f.AccountTypeId == 1)?.Amount) && <p className="mt-1 text-[red]">Refund amount does not exceed the received General amount.</p>}
              {(subtinentId != 3 && subtinentId != 989 && subtinentId != 760) && chackboxButtonAccount('IOLTA Account', 2, paymentAmountPartial, setPaymentamountPartial, parseFloat(String(paymentAmount?.find((f)=> f.AccountTypeId == 2)?.Amount || 0)?.replace(/,/g, "")) == 0 ? true : false)}
              {(subtinentId != 3 && subtinentId != 989 && subtinentId != 760) && <p className="text-[12px] italic">(Refunds for IOLTA account are always issued via check payment method.)</p>}
              {(subtinentId != 3 && subtinentId != 989 && subtinentId != 760) && parseFloat(String(paymentAmount?.find((f)=> f.AccountTypeId == 2)?.Amount || 0)?.replace(/,/g, "")) < parseFloat(paymentAmountPartial?.find((f)=> f.AccountTypeId == 2)?.Amount) && <p className="mt-1 text-[red]">Refund amount does not exceed the received IOLTA amount.</p>}
            </div>
            {(subtinentId != 3 && subtinentId != 989 && subtinentId != 760) && parseFloat(paymentAmountPartial?.reduce((a,c)=> a + parseFloat(String(c.Amount || 0)?.replace(/,/g, "")), 0)) > parseFloat(String(refundAmount)?.replace(/,/g, "")) && <p className="mt-1 text-[red]">Addition of General and IOLTA can not be greater then refund amount.</p>}
            {(subtinentId != 3 && subtinentId != 989 && subtinentId != 760) && parseFloat(paymentAmountPartial?.reduce((a,c)=> a + parseFloat(String(c.Amount || 0)?.replace(/,/g, "")), 0)) < parseFloat(String(refundAmount)?.replace(/,/g, "")) && <p className="mt-1 text-[red]">Addition of General and IOLTA can not be less then refund amount.</p>}
          </div>
           </>}
           </>}
           <div className="bg-white p-0">
            <h1 className="font-semibold mb-2 mt-2">Note</h1>
            <textarea className="pl-2 py-2 w-full border border-gray-300 rounded-md" placeholder='Enter note here ...' value={notes} onChange={(e) => setNotes(e.target.value)} />
          </div>
      </div>
    </div>}
            </div>
            {/* {console.log(transferError,"transferErrorwithdrawError",withdrawError)} */}
            {/* Actions */}
            <div className="flex justify-end gap-3 mt-6">
              
              <button
                onClick={CloseModalFunc}
                className="px-4 py-2 text-gray-600 hover:text-gray-800"
              >
                Cancel
              </button>
              {isTransfer == true ? <button className={`px-4 py-2 ${(transferError == true) ? 'bg-gray-600 cursor-not-allowed hover:bg-gray-600' : 'bg-blue-600 hover:bg-blue-700'} text-white rounded-md`} onClick={()=> {TransferSubmit()}} 
              disabled={transferError == true ? true : false}
              >
                Transfer
              </button>:isWithdraw == true ? <button className={`px-4 py-2 ${withdrawError == true ? 'bg-gray-600 cursor-not-allowed hover:bg-gray-600' : 'bg-blue-600 hover:bg-blue-700'} text-white rounded-md`} onClick={()=> {submitWithdraw()}} disabled={withdrawError == true ? true : false}>
                Withdraw
              </button> :<button 
                className={`px-4 py-2 ${(refundErr != '' || (requestbtnDisable == true && !((subtinentId == 3 || subtinentId == 989 || subtinentId == 760) && refundType == 'Yes'))) ? 'bg-gray-600 cursor-not-allowed hover:bg-gray-600' : 'bg-blue-600 hover:bg-blue-700'} text-white rounded-md`} 
                onClick={()=> {
                  submitData()
                }} 
                disabled={refundErr != '' || (requestbtnDisable == true && !((subtinentId == 3 || subtinentId == 989 || subtinentId == 760) && refundType == 'Yes')) ? true : false}>
                Request
              </button>}
            </div>

          </div>
        </div>
      )}
    
    {multipleRefundCancel?.length > 0  && <>(
        <div className="fixed inset-0 z-20 flex items-center justify-center bg-black/50">
          <div className="relative bg-white rounded-lg shadow-lg w-full max-w-xl p-3 max-h-[96vh] overflow-hidden flex flex-col">
            {/* Close Button */}
            <button
              onClick={() => setMultipleRefundcancel([])}
              aria-label="Close modal"
              className="absolute top-4 right-4 p-2 rounded-full
                         text-gray-400 hover:bg-gray-100 hover:text-gray-700
                         focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            {/* Header */}
            <h2 className="text-lg font-semibold text-gray-800 p-2">
              Refund Cancel
            </h2>

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-2">
            <p className="font-semibold py-2">There are multiple refund requests for this order. Please cancel them from here:</p>
              {multipleRefundCancel?.map((e)=>{
              let accountType = JSON.parse(e?.accountType)[0]?.AccountTypeId
              let accountTypeName = accountType == 1 ? 'General' : 'IOLTA'
                return <div className="mx-0 mb-3 px-2 py-2 bg-gray-100 rounded text-[15px]">
                    <p>Matter No: {e?.seriveMatNo}</p>
                    <p>Service: {e?.productName}</p>
                    <p>Total Paid: ${e.refundBasedTotalCost}</p>
                    <p>Account Type: {accountTypeName}</p>
                    <p>Refunded Amount: ${e.totalRefundCost}</p>
                    <p className="font-medium text-red-600">
                    Refund Requested: ${e.totalCost}
                    </p>
                    <p>Status: {e.statusName}</p>
                    <div className="flex justify-end">
                    {<button className="px-2 py-1 bg-red-500 hover:bg-red-600 text-white rounded-md mt-1" onClick={()=>cancelMultipleRefund(e)}>Cancel Request</button>}
                    </div>
                </div>
                
              })}
            </div>

        </div>
      </div>)</>}
    </>
}

export default Refund;